webpackJsonp([0],{

/***/ 210:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Editor_vue__ = __webpack_require__(244);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31a18331_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Editor_vue__ = __webpack_require__(288);
function injectStyle (ssrContext) {
  __webpack_require__(264)
}
var normalizeComponent = __webpack_require__(27)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Editor_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31a18331_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Editor_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 213:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__slide_elements_TextElement__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__slide_elements_ImageElement__ = __webpack_require__(235);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'current-slide',
  props: {
    slides: { type: Array, default: [] },
    selectedSlideIndex: { type: Number, default: 0 },
    zoomLevel: { type: Number, default: 1 }
  },
  components: {
    'text-element': __WEBPACK_IMPORTED_MODULE_0__slide_elements_TextElement__["a" /* default */],
    'image-element': __WEBPACK_IMPORTED_MODULE_1__slide_elements_ImageElement__["a" /* default */]
  },
  computed: {
    currentSlide: function currentSlide() {
      return this.slides.length && this.slides[this.selectedSlideIndex] ? this.slides[this.selectedSlideIndex] : null;
    },
    textElements: function textElements() {
      return this.currentSlide ? this.currentSlide.elements.filter(function (el) {
        return el.type === 'TEXT';
      }) : [];
    },
    imageElements: function imageElements() {
      return this.currentSlide ? this.currentSlide.elements.filter(function (el) {
        return el.type === 'IMAGE';
      }) : [];
    },
    slideProperties: function slideProperties() {
      return {
        '--canvas-zoom-level': this.zoomLevel,
        '--canvas-background-colour': this.currentSlide ? this.currentSlide.backgroundColour : '#FFFFFF'
      };
    },
    presenterMode: function presenterMode() {
      return this.$route.name === 'presenter';
    }
  }
});

/***/ }),

/***/ 214:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ElementWrapper__ = __webpack_require__(215);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'text-element',
  components: {
    'element-wrapper': __WEBPACK_IMPORTED_MODULE_0__ElementWrapper__["a" /* default */]
  },
  props: { element: Object },
  computed: {
    textX: function textX() {
      return this.element.properties.x;
    },
    textY: function textY() {
      return this.element.properties.y;
    },
    fontFamily: function fontFamily() {
      return this.element.properties.fontFamily;
    },
    fontSize: function fontSize() {
      return this.element.properties.fontSize;
    },
    content: function content() {
      return this.element.properties.content;
    },
    fill: function fill() {
      return this.element.properties.fill;
    }
  }
});

/***/ }),

/***/ 215:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ElementWrapper_vue__ = __webpack_require__(216);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_605053b3_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ElementWrapper_vue__ = __webpack_require__(233);
function injectStyle (ssrContext) {
  __webpack_require__(227)
}
var normalizeComponent = __webpack_require__(27)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-605053b3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ElementWrapper_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_605053b3_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ElementWrapper_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 216:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__InspectingUserLabel__ = __webpack_require__(229);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'element-wrapper',
  props: {
    element: Object
  },
  components: {
    'inspecting-user-label': __WEBPACK_IMPORTED_MODULE_3__InspectingUserLabel__["a" /* default */]
  },
  data: function data() {
    return {
      actualEl: null,
      bbox: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('editor', ['selectedElementIndex']), {
    computedStyles: function computedStyles() {
      return {
        'inspecting': this.selectedElementIndex === this.element.id
      };
    },
    containerX: function containerX() {
      return this.bbox ? this.bbox.x - 10 : 0;
    },
    containerY: function containerY() {
      return this.bbox ? this.bbox.y - 10 : 0;
    },
    containerWidth: function containerWidth() {
      return this.bbox ? this.bbox.width + 20 : 0;
    },
    containerHeight: function containerHeight() {
      return this.bbox ? this.bbox.height + 20 : 0;
    }
  }),
  watch: {
    element: {
      handler: function handler() {
        return this.updateBBox(this.actualEl);
      },
      deep: true
    },
    currentElement: {
      handler: function handler() {
        return this.updateBBox(this.actualEl);
      },
      deep: true
    },
    currentSlide: {
      handler: function handler() {
        return this.updateBBox(this.actualEl);
      },
      deep: true
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('editor', ['inspectElement', 'currentElement', 'currentSlide', 'updateCoordinates']), __WEBPACK_IMPORTED_MODULE_2__helpers__["a" /* default */]),
  mounted: function mounted() {
    this.actualEl = this.$slots['actual-element'][0].elm;
    this.updateBBox(this.actualEl);
  }
});

/***/ }),

/***/ 217:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  updateBBox: function updateBBox(el) {
    var _this = this;

    return this.$nextTick(function () {
      try {
        _this.bbox = el.getBBox();
      } catch (_) {
        // Workaround for FF bug #612118 (https://bugzilla.mozilla.org/show_bug.cgi?id=612118)
        // getBBox() will throw an exception if the element
        // is not attached and rendered, but there is no reliable way to check for this
        setTimeout(function () {
          // Try again in 3 seconds
          _this.updateBBox(el);
        }, 3000);
      }
    });
  }
});

/***/ }),

/***/ 218:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers__ = __webpack_require__(217);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'inspecting-user-label',
  props: {
    x: Number,
    y: Number
  },
  data: function data() {
    return {
      bbox: null
    };
  },

  computed: {
    containerX: function containerX() {
      return this.bbox ? this.bbox.x - 10 : 0;
    },
    containerY: function containerY() {
      return this.bbox ? this.bbox.y - 10 : 0;
    },
    containerWidth: function containerWidth() {
      return this.bbox ? this.bbox.width + 20 : 0;
    },
    containerHeight: function containerHeight() {
      return this.bbox ? this.bbox.height + 20 : 0;
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__helpers__["a" /* default */]),
  watch: {
    element: {
      handler: function handler() {
        return this.updateBBox(this.actualEl);
      },
      deep: true
    },
    currentElement: {
      handler: function handler() {
        return this.updateBBox(this.actualEl);
      },
      deep: true
    },
    currentSlide: {
      handler: function handler() {
        return this.updateBBox(this.actualEl);
      },
      deep: true
    }
  },
  mounted: function mounted() {
    this.updateBBox(this.$refs.textEl, this);
  }
});

/***/ }),

/***/ 219:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ElementWrapper__ = __webpack_require__(215);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'image-element',
  components: {
    'element-wrapper': __WEBPACK_IMPORTED_MODULE_0__ElementWrapper__["a" /* default */]
  },
  props: { element: Object },
  computed: {
    href: function href() {
      return this.element.properties.href;
    },
    x: function x() {
      return this.element.properties.x;
    },
    y: function y() {
      return this.element.properties.y;
    },
    width: function width() {
      return this.element.properties.width;
    },
    height: function height() {
      return this.element.properties.height;
    }
  }
});

/***/ }),

/***/ 221:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CurrentSlide_vue__ = __webpack_require__(213);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dbe657dc_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CurrentSlide_vue__ = __webpack_require__(239);
function injectStyle (ssrContext) {
  __webpack_require__(222)
}
var normalizeComponent = __webpack_require__(27)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CurrentSlide_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dbe657dc_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CurrentSlide_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 222:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(223);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(205)("5bb3c499", content, true, {});

/***/ }),

/***/ 223:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(204)(true);
// imports


// module
exports.push([module.i, ".current-slide{grid-area:current-slide;grid-row:1/-1;overflow:hidden;display:grid;-webkit-box-align:center;-ms-flex-align:center;align-items:center;justify-items:center}.editor .current-slide{padding:3em}.presenter .current-slide svg{width:100vw;height:60vw;max-height:100vh;max-width:166.66vh}.current-slide svg{background-color:var(--canvas-background-colour);outline:3px solid rgba(0,0,0,.2);-webkit-box-shadow:0 0 15px rgba(0,0,0,.7);box-shadow:0 0 15px rgba(0,0,0,.7);-webkit-transform:scale(var(--canvas-zoom-level));transform:scale(var(--canvas-zoom-level))}.current-slide svg .hoverableElement .hoverState{visibility:hidden}.current-slide svg .hoverableElement:hover .hoverState{visibility:visible;fill:none;stroke:rgba(0,0,0,.4);stroke-width:2px;stroke-dasharray:4;stroke-linecap:square}.current-slide svg .hoverableElement:hover{cursor:move}.presenter .current-slide{background-color:#000;padding:0}.presenter .current-slide svg{background-color:var(--canvas-background-colour);outline:none;-webkit-box-shadow:none;box-shadow:none}.presenter .current-slide,.presenter .current-slide>*{cursor:default}@-webkit-keyframes fadeIn{0%{opacity:1}to{opacity:0}}@keyframes fadeIn{0%{opacity:1}to{opacity:0}}@-webkit-keyframes slideDown{0%{opacity:.5;-webkit-transform:translateY(-100%);transform:translateY(-100%)}to{opacity:1;-webkit-transform:translateY(0);transform:translateY(0)}}@keyframes slideDown{0%{opacity:.5;-webkit-transform:translateY(-100%);transform:translateY(-100%)}to{opacity:1;-webkit-transform:translateY(0);transform:translateY(0)}}@-webkit-keyframes slideUp{0%{opacity:.5;-webkit-transform:translateY(100%);transform:translateY(100%)}to{opacity:1;-webkit-transform:translateY(0);transform:translateY(0)}}@keyframes slideUp{0%{opacity:.5;-webkit-transform:translateY(100%);transform:translateY(100%)}to{opacity:1;-webkit-transform:translateY(0);transform:translateY(0)}}@-webkit-keyframes slideInRight{0%{opacity:.5;-webkit-transform:translateX(100%);transform:translateX(100%)}to{opacity:1;-webkit-transform:translateX(0);transform:translateX(0)}}@keyframes slideInRight{0%{opacity:.5;-webkit-transform:translateX(100%);transform:translateX(100%)}to{opacity:1;-webkit-transform:translateX(0);transform:translateX(0)}}@-webkit-keyframes scaleIn{0%{opacity:.5;-webkit-transform:scale(.5);transform:scale(.5)}to{opacity:1;-webkit-transform:scale(1);transform:scale(1)}}@keyframes scaleIn{0%{opacity:.5;-webkit-transform:scale(.5);transform:scale(.5)}to{opacity:1;-webkit-transform:scale(1);transform:scale(1)}}.presenter .current-slide.fadeIn:before{content:\"\";position:absolute;top:0;left:0;right:0;bottom:0;opacity:0;background-color:#fff;z-index:10;-webkit-animation:1s ease-in-out .1s 1 fadeIn;animation:1s ease-in-out .1s 1 fadeIn}.presenter .current-slide.slideDown{-webkit-animation:.4s ease-in-out .1s 1 slideDown;animation:.4s ease-in-out .1s 1 slideDown;-webkit-transform:none;transform:none}.presenter .current-slide.slideUp{-webkit-animation:.4s ease-in-out .1s 1 slideUp;animation:.4s ease-in-out .1s 1 slideUp;-webkit-transform:none;transform:none}.presenter .current-slide.slideInRight{-webkit-animation:.4s ease-in-out .1s 1 slideInRight;animation:.4s ease-in-out .1s 1 slideInRight;-webkit-transform:none;transform:none}.presenter .current-slide.scaleIn{-webkit-animation:.4s ease-in-out .1s 1 scaleIn;animation:.4s ease-in-out .1s 1 scaleIn;-webkit-transform:none;transform:none}", "", {"version":3,"sources":["/home/forge/slidekick.daniel-waghorn.com/src/components/CurrentSlide.vue"],"names":[],"mappings":"AACA,eACE,wBAAyB,AACzB,cAAiB,AAEjB,gBAAiB,AACjB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,oBAAsB,CACvB,AACD,uBACE,WAAa,CACd,AACD,8BAGE,YAAa,AACb,YAAa,AACb,iBAAkB,AAClB,kBAAoB,CACrB,AACD,mBACE,iDAAkD,AAClD,iCAAsC,AACtC,2CAAgD,AACxC,mCAAwC,AAEhD,kDAAmD,AAE3C,yCAA2C,CACpD,AACD,iDACE,iBAAmB,CACpB,AACD,uDACE,mBAAoB,AACpB,UAAW,AACX,sBAA2B,AAC3B,iBAAkB,AAClB,mBAAoB,AACpB,qBAAuB,CACxB,AACD,2CACE,WAAa,CACd,AACD,0BACE,sBAAwB,AACxB,SAAW,CACZ,AACD,8BACE,iDAAkD,AAClD,aAAc,AACd,wBAAyB,AACjB,eAAiB,CAC1B,AACD,sDAEE,cAAgB,CACjB,AACD,0BACA,GACI,SAAW,CACd,AACD,GACI,SAAW,CACd,CACA,AACD,kBACA,GACI,SAAW,CACd,AACD,GACI,SAAW,CACd,CACA,AACD,6BACA,GACI,WAAa,AACb,oCAAqC,AAC7B,2BAA6B,CACxC,AACD,GACI,UAAW,AACX,gCAAiC,AACzB,uBAAyB,CACpC,CACA,AACD,qBACA,GACI,WAAa,AACb,oCAAqC,AAC7B,2BAA6B,CACxC,AACD,GACI,UAAW,AACX,gCAAiC,AACzB,uBAAyB,CACpC,CACA,AACD,2BACA,GACI,WAAa,AACb,mCAAoC,AAC5B,0BAA4B,CACvC,AACD,GACI,UAAW,AACX,gCAAiC,AACzB,uBAAyB,CACpC,CACA,AACD,mBACA,GACI,WAAa,AACb,mCAAoC,AAC5B,0BAA4B,CACvC,AACD,GACI,UAAW,AACX,gCAAiC,AACzB,uBAAyB,CACpC,CACA,AACD,gCACA,GACI,WAAa,AACb,mCAAoC,AAC5B,0BAA4B,CACvC,AACD,GACI,UAAW,AACX,gCAAiC,AACzB,uBAAyB,CACpC,CACA,AACD,wBACA,GACI,WAAa,AACb,mCAAoC,AAC5B,0BAA4B,CACvC,AACD,GACI,UAAW,AACX,gCAAiC,AACzB,uBAAyB,CACpC,CACA,AACD,2BACA,GACI,WAAa,AACb,4BAA8B,AACtB,mBAAsB,CACjC,AACD,GACI,UAAW,AACX,2BAA4B,AACpB,kBAAoB,CAC/B,CACA,AACD,mBACA,GACI,WAAa,AACb,4BAA8B,AACtB,mBAAsB,CACjC,AACD,GACI,UAAW,AACX,2BAA4B,AACpB,kBAAoB,CAC/B,CACA,AACD,wCACE,WAAY,AACZ,kBAAmB,AACnB,MAAO,AACP,OAAQ,AACR,QAAS,AACT,SAAU,AACV,UAAW,AACX,sBAAwB,AACxB,WAAY,AACZ,8CAAgD,AACxC,qCAAwC,CACjD,AACD,oCACE,kDAAqD,AAC7C,0CAA6C,AACrD,uBAAwB,AAChB,cAAgB,CACzB,AACD,kCACE,gDAAmD,AAC3C,wCAA2C,AACnD,uBAAwB,AAChB,cAAgB,CACzB,AACD,uCACE,qDAAwD,AAChD,6CAAgD,AACxD,uBAAwB,AAChB,cAAgB,CACzB,AACD,kCACE,gDAAmD,AAC3C,wCAA2C,AACnD,uBAAwB,AAChB,cAAgB,CACzB","file":"CurrentSlide.vue","sourcesContent":["\n.current-slide {\n  grid-area: current-slide;\n  grid-row: 1 / -1;\n  \n  overflow: hidden;\n  display: grid;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  justify-items: center;\n}\n.editor .current-slide {\n  padding: 3em;\n}\n.presenter .current-slide svg {\n  /* Styles to preserve 5:3 aspect ratio */\n\n  width: 100vw;\n  height: 60vw; /* 3/5 = 0.6 */\n  max-height: 100vh;\n  max-width: 166.66vh; /* 5/3 = 1.6666 */\n}\n.current-slide svg {\n  background-color: var(--canvas-background-colour);\n  outline: 3px solid rgba(0, 0, 0, 0.2);\n  -webkit-box-shadow: 0 0 15px rgba(0, 0, 0, 0.7);\n          box-shadow: 0 0 15px rgba(0, 0, 0, 0.7);\n  \n  -webkit-transform: scale(var(--canvas-zoom-level));\n  \n          transform: scale(var(--canvas-zoom-level));\n}\n.current-slide svg .hoverableElement .hoverState {\n  visibility: hidden;\n}\n.current-slide svg .hoverableElement:hover .hoverState {\n  visibility: visible;\n  fill: none;\n  stroke: rgba(0, 0, 0, 0.4);\n  stroke-width: 2px;\n  stroke-dasharray: 4;\n  stroke-linecap: square;\n}\n.current-slide svg .hoverableElement:hover {\n  cursor: move;\n}\n.presenter .current-slide {\n  background-color: black;\n  padding: 0;\n}\n.presenter .current-slide svg {\n  background-color: var(--canvas-background-colour);\n  outline: none;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n}\n.presenter .current-slide,\n.presenter .current-slide > * {\n  cursor: default;\n}\n@-webkit-keyframes fadeIn {\n0% {\n    opacity: 1;\n}\n100% {\n    opacity: 0;\n}\n}\n@keyframes fadeIn {\n0% {\n    opacity: 1;\n}\n100% {\n    opacity: 0;\n}\n}\n@-webkit-keyframes slideDown {\n0% {\n    opacity: 0.5;\n    -webkit-transform: translateY(-100%);\n            transform: translateY(-100%);\n}\n100% {\n    opacity: 1;\n    -webkit-transform: translateY(0);\n            transform: translateY(0);\n}\n}\n@keyframes slideDown {\n0% {\n    opacity: 0.5;\n    -webkit-transform: translateY(-100%);\n            transform: translateY(-100%);\n}\n100% {\n    opacity: 1;\n    -webkit-transform: translateY(0);\n            transform: translateY(0);\n}\n}\n@-webkit-keyframes slideUp {\n0% {\n    opacity: 0.5;\n    -webkit-transform: translateY(100%);\n            transform: translateY(100%);\n}\n100% {\n    opacity: 1;\n    -webkit-transform: translateY(0);\n            transform: translateY(0);\n}\n}\n@keyframes slideUp {\n0% {\n    opacity: 0.5;\n    -webkit-transform: translateY(100%);\n            transform: translateY(100%);\n}\n100% {\n    opacity: 1;\n    -webkit-transform: translateY(0);\n            transform: translateY(0);\n}\n}\n@-webkit-keyframes slideInRight {\n0% {\n    opacity: 0.5;\n    -webkit-transform: translateX(100%);\n            transform: translateX(100%);\n}\n100% {\n    opacity: 1;\n    -webkit-transform: translateX(0);\n            transform: translateX(0);\n}\n}\n@keyframes slideInRight {\n0% {\n    opacity: 0.5;\n    -webkit-transform: translateX(100%);\n            transform: translateX(100%);\n}\n100% {\n    opacity: 1;\n    -webkit-transform: translateX(0);\n            transform: translateX(0);\n}\n}\n@-webkit-keyframes scaleIn {\n0% {\n    opacity: 0.5;\n    -webkit-transform: scale(0.5);\n            transform: scale(0.5);\n}\n100% {\n    opacity: 1;\n    -webkit-transform: scale(1);\n            transform: scale(1);\n}\n}\n@keyframes scaleIn {\n0% {\n    opacity: 0.5;\n    -webkit-transform: scale(0.5);\n            transform: scale(0.5);\n}\n100% {\n    opacity: 1;\n    -webkit-transform: scale(1);\n            transform: scale(1);\n}\n}\n.presenter .current-slide.fadeIn::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  opacity: 0;\n  background-color: white;\n  z-index: 10;\n  -webkit-animation: 1s ease-in-out 0.1s 1 fadeIn;\n          animation: 1s ease-in-out 0.1s 1 fadeIn;\n}\n.presenter .current-slide.slideDown {\n  -webkit-animation: 0.4s ease-in-out 0.1s 1 slideDown;\n          animation: 0.4s ease-in-out 0.1s 1 slideDown;\n  -webkit-transform: none;\n          transform: none;\n}\n.presenter .current-slide.slideUp {\n  -webkit-animation: 0.4s ease-in-out 0.1s 1 slideUp;\n          animation: 0.4s ease-in-out 0.1s 1 slideUp;\n  -webkit-transform: none;\n          transform: none;\n}\n.presenter .current-slide.slideInRight {\n  -webkit-animation: 0.4s ease-in-out 0.1s 1 slideInRight;\n          animation: 0.4s ease-in-out 0.1s 1 slideInRight;\n  -webkit-transform: none;\n          transform: none;\n}\n.presenter .current-slide.scaleIn {\n  -webkit-animation: 0.4s ease-in-out 0.1s 1 scaleIn;\n          animation: 0.4s ease-in-out 0.1s 1 scaleIn;\n  -webkit-transform: none;\n          transform: none;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 224:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TextElement_vue__ = __webpack_require__(214);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_011b23b5_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TextElement_vue__ = __webpack_require__(234);
function injectStyle (ssrContext) {
  __webpack_require__(225)
}
var normalizeComponent = __webpack_require__(27)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TextElement_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_011b23b5_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TextElement_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 225:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(226);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(205)("26770116", content, true, {});

/***/ }),

/***/ 226:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(204)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"TextElement.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 227:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(228);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(205)("80b7ec52", content, true, {});

/***/ }),

/***/ 228:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(204)(true);
// imports


// module
exports.push([module.i, "@-webkit-keyframes rotateDashes-data-v-605053b3{0%{stroke-dashoffset:0}to{stroke-dashoffset:60}}@keyframes rotateDashes-data-v-605053b3{0%{stroke-dashoffset:0}to{stroke-dashoffset:60}}g[data-v-605053b3]:hover{cursor:pointer}g:hover .bbox[data-v-605053b3]{stroke:rgba(0,0,0,.4)}g.inspecting .bbox[data-v-605053b3]{stroke-linecap:round;stroke:rgba(0,0,0,.6);stroke-dasharray:15px;-webkit-animation:rotateDashes-data-v-605053b3 5s infinite linear;animation:rotateDashes-data-v-605053b3 5s infinite linear}", "", {"version":3,"sources":["/home/forge/slidekick.daniel-waghorn.com/src/components/slide-elements/ElementWrapper.vue"],"names":[],"mappings":"AACA,gDACA,GACI,mBAAqB,CACxB,AACD,GACI,oBAAsB,CACzB,CACA,AACD,wCACA,GACI,mBAAqB,CACxB,AACD,GACI,oBAAsB,CACzB,CACA,AACD,yBACE,cAAgB,CACjB,AACD,+BACE,qBAA2B,CAC5B,AACD,oCACE,qBAAsB,AACtB,sBAA2B,AAC3B,sBAAuB,AACvB,kEAAmE,AAC3D,yDAA2D,CACpE","file":"ElementWrapper.vue","sourcesContent":["\n@-webkit-keyframes rotateDashes-data-v-605053b3 {\n0% {\n    stroke-dashoffset: 0;\n}\n100% {\n    stroke-dashoffset: 60;\n}\n}\n@keyframes rotateDashes-data-v-605053b3 {\n0% {\n    stroke-dashoffset: 0;\n}\n100% {\n    stroke-dashoffset: 60;\n}\n}\ng[data-v-605053b3]:hover {\n  cursor: pointer;\n}\ng:hover .bbox[data-v-605053b3] {\n  stroke: rgba(0, 0, 0, 0.4);\n}\ng.inspecting .bbox[data-v-605053b3] {\n  stroke-linecap: round;\n  stroke: rgba(0, 0, 0, 0.6);\n  stroke-dasharray: 15px;\n  -webkit-animation: rotateDashes-data-v-605053b3 5s infinite linear;\n          animation: rotateDashes-data-v-605053b3 5s infinite linear;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 229:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InspectingUserLabel_vue__ = __webpack_require__(218);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c37738c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InspectingUserLabel_vue__ = __webpack_require__(232);
function injectStyle (ssrContext) {
  __webpack_require__(230)
}
var normalizeComponent = __webpack_require__(27)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InspectingUserLabel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c37738c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InspectingUserLabel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 230:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(231);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(205)("eed78194", content, true, {});

/***/ }),

/***/ 231:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(204)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"InspectingUserLabel.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 232:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g',[_c('rect',{attrs:{"fill":"black","x":_vm.containerX,"y":_vm.containerY,"width":_vm.containerWidth,"height":_vm.containerHeight}}),_vm._v(" "),_c('text',{ref:"textEl",attrs:{"x":_vm.x,"y":_vm.y,"font-size":"10","font-weight":"bold","fill":"red"}},[_vm._v("\n    PAUL\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 233:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g',{class:_vm.computedStyles,on:{"click":function($event){$event.stopPropagation();_vm.inspectElement(_vm.element.id)},"mouseover":_vm.updateBBox}},[_c('rect',{staticClass:"bbox",attrs:{"width":_vm.containerWidth,"height":_vm.containerHeight,"x":_vm.containerX,"y":_vm.containerY,"fill":"none","stroke-width":"2px","stroke":"none"}}),_vm._v(" "),_vm._t("actual-element",[_c('text',{attrs:{"x":"0","y":"0","font-size":"12","fill":"black"}},[_vm._v("Unable to load element")])])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 234:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('element-wrapper',{attrs:{"element":_vm.element}},[_c('text',{attrs:{"slot":"actual-element","dominant-baseline":"hanging","x":_vm.textX,"y":_vm.textY,"font-family":_vm.fontFamily,"font-size":_vm.fontSize,"fill":_vm.fill},slot:"actual-element"},[_vm._v("\n    "+_vm._s(_vm.content)+"\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 235:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ImageElement_vue__ = __webpack_require__(219);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35dbfdd0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ImageElement_vue__ = __webpack_require__(238);
function injectStyle (ssrContext) {
  __webpack_require__(236)
}
var normalizeComponent = __webpack_require__(27)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ImageElement_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35dbfdd0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ImageElement_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 236:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(237);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(205)("9a5252f8", content, true, {});

/***/ }),

/***/ 237:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(204)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"ImageElement.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 238:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('element-wrapper',{attrs:{"element":_vm.element}},[_c('image',{attrs:{"slot":"actual-element","x":_vm.x,"y":_vm.y,"width":_vm.width,"height":_vm.height,"href":_vm.href},slot:"actual-element"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 239:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"current-slide"},[_c('svg',{style:(_vm.slideProperties),attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 500 300","preserveAspectRatio":"xMinYMax meet"}},[_vm._l((_vm.imageElements.reverse()),function(imageElement){return _c('image-element',{key:imageElement.id,attrs:{"element":imageElement}})}),_vm._v(" "),_vm._l((_vm.textElements.reverse()),function(textElement){return _c('text-element',{key:textElement.id,attrs:{"element":textElement}})})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 244:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_socket_handlers__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SlidesToolbar_vue__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Toolbox_vue__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Inspector_vue__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SlideControls_vue__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__CurrentSlide_vue__ = __webpack_require__(221);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'editor',
  components: {
    'slides-toolbar': __WEBPACK_IMPORTED_MODULE_3__SlidesToolbar_vue__["a" /* default */],
    'toolbox': __WEBPACK_IMPORTED_MODULE_4__Toolbox_vue__["a" /* default */],
    'inspector': __WEBPACK_IMPORTED_MODULE_5__Inspector_vue__["a" /* default */],
    'slide-controls': __WEBPACK_IMPORTED_MODULE_6__SlideControls_vue__["a" /* default */],
    'current-slide': __WEBPACK_IMPORTED_MODULE_7__CurrentSlide_vue__["a" /* default */]
  },
  data: function data() {
    return {
      loading: true
    };
  },
  created: function created() {
    var _this = this;

    this.$store.dispatch('editor/fetchPresentation', this.$route.params.presentationId)
    // eslint-disable-next-line
    .then(function () {
      return _this.loading = false;
    }).catch(function () {
      window.alert('Failed to load presentation.');
      _this.$router.go(-1);
    });
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['current_user', 'is_logged_in']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('editor', ['socket', 'presentation', 'slides', 'selectedSlideIndex', 'selectedElementIndex', 'zoomLevel']), {
    computedStyles: function computedStyles() {
      return {
        'no-slides': !this.slides || !this.slides.length
      };
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('editor', ['initSocket', 'updateTitle', 'setSlides', 'setElements', 'replaceSlide', 'setUsersList', 'savePresentation']), {
    inspectElement: function inspectElement(index) {
      this.$store.commit('editor/setSelectedElementIndex', index);
    },
    clearInspector: function clearInspector(e) {
      if (e.target.tagName === 'svg') {
        this.$store.commit('editor/setSelectedElementIndex', null);
      }
    }
  }),
  mounted: function mounted() {
    var vm = this;
    this.initSocket();
    Object(__WEBPACK_IMPORTED_MODULE_2__assets_socket_handlers__["a" /* default */])(vm, this.socket);
  },
  beforeDestroy: function beforeDestroy() {
    this.socket.close();
  }
});

/***/ }),

/***/ 245:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(28);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'slides-toolbar',
  data: function data() {
    return {
      draggingSlideIndex: null,
      replaceSlideIndex: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('editor', ['slides', 'selectedSlideIndex'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('editor', ['selectSlideFromList', 'createSlide', 'deleteSlide', 'moveSlide']), {
    dragstart: function dragstart(slideIndex) {
      this.draggingSlideIndex = slideIndex;
    },
    dragover: function dragover(slideIndex) {
      this.replaceSlideIndex = slideIndex;
    },
    dragend: function dragend() {
      if (this.draggingSlideIndex !== this.replaceSlideIndex) {
        this.moveSlide({
          draggingSlideIndex: this.draggingSlideIndex,
          replaceSlideIndex: this.replaceSlideIndex
        });
      }
      this.draggingSlideIndex = null;
      this.replaceSlideIndex = null;
    }
  })
});

/***/ }),

/***/ 246:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(28);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'toolbox',
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('editor', ['createText', 'createImage']))
});

/***/ }),

/***/ 247:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ColourPicker__ = __webpack_require__(278);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'inspector',
  components: {
    'colour-picker': __WEBPACK_IMPORTED_MODULE_2__ColourPicker__["a" /* default */]
  },
  data: function data() {
    return {
      fonts: [{ name: 'Arial' }, { name: 'Verdana' }, { name: 'Helvetica' }, { name: 'Comic Sans MS' }, { name: 'Impact' }, { name: 'Times New Roman' }, { name: 'Georgia' }, { name: 'Courier' }, { name: 'Courier New' }]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('editor', ['currentSlide', 'currentElement']), {
    isTextElement: function isTextElement() {
      return this.currentElement ? this.currentElement && this.currentElement.type === 'TEXT' : false;
    },

    backgroundColour: {
      get: function get() {
        return this.currentSlide ? this.currentSlide.backgroundColour : '#FFFFFF';
      },
      set: function set(value) {
        return this.updateBackgroundColour(value);
      }
    },
    xPosition: {
      get: function get() {
        return this.currentElement ? Number(this.currentElement.properties.x.substr(0, this.currentElement.properties.x.length - 2)) : 0;
      },
      set: function set(value) {
        this.updateX({ element: this.currentElement, value: value + 'px' });
      }
    },
    yPosition: {
      get: function get() {
        return this.currentElement ? Number(this.currentElement.properties.y.substr(0, this.currentElement.properties.y.length - 2)) : 0;
      },
      set: function set(value) {
        this.updateY({ element: this.currentElement, value: value + 'px' });
      }
    },
    fill: {
      get: function get() {
        return this.currentElement && this.currentElement.properties.fill ? this.currentElement.properties.fill : '#000000';
      },
      set: function set(value) {
        this.updateFill({ element: this.currentElement, value: value });
      }
    },
    content: {
      get: function get() {
        return this.currentElement && this.currentElement.properties.content ? this.currentElement.properties.content : '';
      },
      set: function set(value) {
        this.updateContent({ element: this.currentElement, value: value });
      }
    },
    fontFamily: {
      get: function get() {
        return this.currentElement ? this.currentElement.properties.fontFamily : '';
      },
      set: function set(value) {
        this.updateFontFamily({ element: this.currentElement, value: value });
      }
    },
    fontSize: {
      get: function get() {
        return this.currentElement ? Number(this.currentElement.properties.fontSize.substr(0, this.currentElement.properties.fontSize.length - 2)) : '0px';
      },
      set: function set(value) {
        this.updateFontSize({ element: this.currentElement, value: value + 'px' });
      }
    }
  }),
  watch: {
    currentElement: function currentElement() {
      var _this = this;

      this.$el.classList.remove('changed');
      setTimeout(function () {
        _this.$el.classList.add('changed');
      }, 100);
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('editor', ['updateBackgroundColour', 'updateX', 'updateY', 'updateFontFamily', 'updateFontSize', 'updateFill', 'updateContent', 'deleteElement']), {
    toggleSection: function toggleSection(e) {
      var sectionEl = e.currentTarget.parentElement.parentElement;
      sectionEl.classList.toggle('hidden');
    }
  })
});

/***/ }),

/***/ 248:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_color__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_color___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_color__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'colour-picker',
  components: {
    'compact-picker': __WEBPACK_IMPORTED_MODULE_0_vue_color__["Sketch"]
  },
  props: {
    value: String
  },
  data: function data() {
    return {
      active: false
    };
  },

  computed: {
    hex: {
      get: function get() {
        return this.value;
      },
      set: function set(_ref) {
        var value = _ref.hex;

        return this.$emit('update:value', value);
      }
    },
    previewStyle: function previewStyle() {
      return {
        'background-color': this.value
      };
    }
  },
  methods: {
    onMousedown: function onMousedown() {
      // Prevent loss of focus from input event when using colour picker
      this.$refs.field.focus();
    }
  }
});

/***/ }),

/***/ 249:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(28);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'slide-controls',
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['current_user']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('editor', ['zoomLevel', 'activeUsers'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('editor', ['zoomIn', 'zoomOut'])),
  filters: {
    percent: function percent(value) {
      return Math.round(value * 100) + '%';
    },
    initial: function initial(name) {
      return name.length ? name[0] : '';
    }
  },
  mounted: function mounted() {
    this.canvas = document.querySelector('.current-slide svg');
  }
});

/***/ }),

/***/ 264:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(265);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(205)("5b6ecde8", content, true, {});

/***/ }),

/***/ 265:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(204)(true);
// imports


// module
exports.push([module.i, ".editor{display:grid;grid-template-areas:\"slides-toolbar   toolbox         inspector\" \"slides-toolbar   current-slide   inspector\" \"slides-toolbar   slide-controls  inspector\";grid-template-columns:250px minmax(300px,1fr) 300px;grid-template-rows:auto 1fr auto;overflow:hidden}@-webkit-keyframes slideInFromLeft{0%{opacity:.5;-webkit-transform:translateX(-100%);transform:translateX(-100%)}to{opacity:1;-webkit-transform:translateX(0);transform:translateX(0)}}@keyframes slideInFromLeft{0%{opacity:.5;-webkit-transform:translateX(-100%);transform:translateX(-100%)}to{opacity:1;-webkit-transform:translateX(0);transform:translateX(0)}}@-webkit-keyframes slideInFromRight{0%{opacity:.5;-webkit-transform:translateX(100%);transform:translateX(100%)}to{opacity:1;-webkit-transform:translateX(0);transform:translateX(0)}}@keyframes slideInFromRight{0%{opacity:.5;-webkit-transform:translateX(100%);transform:translateX(100%)}to{opacity:1;-webkit-transform:translateX(0);transform:translateX(0)}}@-webkit-keyframes slideInFromTop{0%{opacity:.5;-webkit-transform:translateY(-100%);transform:translateY(-100%)}to{opacity:1;-webkit-transform:translateY(0);transform:translateY(0)}}@keyframes slideInFromTop{0%{opacity:.5;-webkit-transform:translateY(-100%);transform:translateY(-100%)}to{opacity:1;-webkit-transform:translateY(0);transform:translateY(0)}}@-webkit-keyframes slideInFromBottom{0%{opacity:.5;-webkit-transform:translateY(100%);transform:translateY(100%)}to{opacity:1;-webkit-transform:translateY(0);transform:translateY(0)}}@keyframes slideInFromBottom{0%{opacity:.5;-webkit-transform:translateY(100%);transform:translateY(100%)}to{opacity:1;-webkit-transform:translateY(0);transform:translateY(0)}}@-webkit-keyframes scale{0%{opacity:0;-webkit-transform:scale(.5);transform:scale(.5)}to{opacity:1;-webkit-transform:scale(1);transform:scale(1)}}@keyframes scale{0%{opacity:0;-webkit-transform:scale(.5);transform:scale(.5)}to{opacity:1;-webkit-transform:scale(1);transform:scale(1)}}@-webkit-keyframes highlightFlash{0%{opacity:1;width:100%}to{opacity:0;width:0}}@keyframes highlightFlash{0%{opacity:1;width:100%}to{opacity:0;width:0}}.editor .slides-toolbar{-webkit-animation:.4s ease-in-out .1s 1 slideInFromLeft;animation:.4s ease-in-out .1s 1 slideInFromLeft}.editor .current-slide{-webkit-animation:.4s ease-in-out 0s 1 scale;animation:.4s ease-in-out 0s 1 scale}.editor .inspector{-webkit-animation:.4s ease-in-out .1s 1 slideInFromRight;animation:.4s ease-in-out .1s 1 slideInFromRight}.editor .no-slides-message{color:#fff;font-size:2em;z-index:-10;opacity:0;grid-row:1/-1;grid-column:2/-1;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;display:grid;grid-gap:1em;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;justify-items:center;-ms-flex-line-pack:center;align-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.editor .no-slides-message i{padding:.5em;border-radius:100px;border:4px solid rgba(0,0,0,.2)}.editor.no-slides .no-slides-message{-webkit-transition:all .4s;transition:all .4s;z-index:5;background-color:var(--dark-grey);opacity:.9}.inspector.changed:before{content:\"\";background-color:hsla(0,0%,100%,.1);position:absolute;top:0;bottom:0;width:0;right:0;z-index:5;opacity:0;-webkit-animation:highlightFlash .7s;animation:highlightFlash .7s;-webkit-animation-iteration-count:1;animation-iteration-count:1}.editor .toolbox{-webkit-animation:.4s ease-in-out .1s 1 slideInFromTop;animation:.4s ease-in-out .1s 1 slideInFromTop}.editor .slide-controls{-webkit-animation:.4s ease-in-out .1s 1 slideInFromBottom;animation:.4s ease-in-out .1s 1 slideInFromBottom}@media only screen and (device-width:375px) and (device-height:812px) and (-webkit-device-pixel-ratio:3){.editor{grid-template-columns:150px minmax(300px,1fr) 150px}}@media (max-width:800px){.editor{grid-template-columns:1fr;grid-template-areas:\"slide-controls\" \"current-slide\"}.editor .no-slides-message{display:none}}", "", {"version":3,"sources":["/home/forge/slidekick.daniel-waghorn.com/src/components/Editor.vue"],"names":[],"mappings":"AACA,QACE,aAAc,AACd,2JAG+C,AAC/C,oDAAsD,AACtD,iCAAkC,AAClC,eAAiB,CAClB,AACD,mCACA,GACI,WAAa,AACb,oCAAqC,AAC7B,2BAA6B,CACxC,AACD,GACI,UAAW,AACX,gCAAiC,AACzB,uBAAyB,CACpC,CACA,AACD,2BACA,GACI,WAAa,AACb,oCAAqC,AAC7B,2BAA6B,CACxC,AACD,GACI,UAAW,AACX,gCAAiC,AACzB,uBAAyB,CACpC,CACA,AACD,oCACA,GACI,WAAa,AACb,mCAAoC,AAC5B,0BAA4B,CACvC,AACD,GACI,UAAW,AACX,gCAAiC,AACzB,uBAAyB,CACpC,CACA,AACD,4BACA,GACI,WAAa,AACb,mCAAoC,AAC5B,0BAA4B,CACvC,AACD,GACI,UAAW,AACX,gCAAiC,AACzB,uBAAyB,CACpC,CACA,AACD,kCACA,GACI,WAAa,AACb,oCAAqC,AAC7B,2BAA6B,CACxC,AACD,GACI,UAAW,AACX,gCAAiC,AACzB,uBAAyB,CACpC,CACA,AACD,0BACA,GACI,WAAa,AACb,oCAAqC,AAC7B,2BAA6B,CACxC,AACD,GACI,UAAW,AACX,gCAAiC,AACzB,uBAAyB,CACpC,CACA,AACD,qCACA,GACI,WAAa,AACb,mCAAoC,AAC5B,0BAA4B,CACvC,AACD,GACI,UAAW,AACX,gCAAiC,AACzB,uBAAyB,CACpC,CACA,AACD,6BACA,GACI,WAAa,AACb,mCAAoC,AAC5B,0BAA4B,CACvC,AACD,GACI,UAAW,AACX,gCAAiC,AACzB,uBAAyB,CACpC,CACA,AACD,yBACA,GACI,UAAW,AACX,4BAA8B,AACtB,mBAAsB,CACjC,AACD,GACI,UAAW,AACX,2BAA4B,AACpB,kBAAoB,CAC/B,CACA,AACD,iBACA,GACI,UAAW,AACX,4BAA8B,AACtB,mBAAsB,CACjC,AACD,GACI,UAAW,AACX,2BAA4B,AACpB,kBAAoB,CAC/B,CACA,AACD,kCACA,GACI,UAAW,AACX,UAAY,CACf,AACD,GACI,UAAW,AACX,OAAS,CACZ,CACA,AACD,0BACA,GACI,UAAW,AACX,UAAY,CACf,AACD,GACI,UAAW,AACX,OAAS,CACZ,CACA,AACD,wBACE,wDAA2D,AACnD,+CAAmD,CAC5D,AACD,uBACE,6CAA+C,AACvC,oCAAuC,CAChD,AACD,mBACE,yDAA4D,AACpD,gDAAoD,CAC7D,AACD,2BACE,WAAa,AACb,cAAe,AACf,YAAa,AACb,UAAW,AACX,cAAiB,AACjB,iBAAoB,AACpB,yBAA0B,AACvB,sBAAuB,AACtB,qBAAsB,AAClB,iBAAkB,AAE1B,aAAc,AACd,aAAc,AACd,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,qBAAsB,AACtB,0BAA2B,AACvB,qBAAsB,AAC1B,yBAA0B,AACtB,sBAAuB,AACnB,kBAAoB,CAC7B,AACD,6BACE,aAAe,AACf,oBAAqB,AACrB,+BAAqC,CACtC,AACD,qCACE,2BAA6B,AAC7B,mBAAqB,AACrB,UAAW,AACX,kCAAmC,AACnC,UAAa,CACd,AACD,0BACE,WAAY,AACZ,oCAA2C,AAC3C,kBAAmB,AACnB,MAAO,AACP,SAAU,AACV,QAAS,AACT,QAAS,AACT,UAAW,AACX,UAAW,AACX,qCAAuC,AAC/B,6BAA+B,AACvC,oCAAqC,AACrC,2BAA6B,CAC9B,AACD,iBACE,uDAA0D,AAClD,8CAAkD,CAC3D,AACD,wBACE,0DAA6D,AACrD,iDAAqD,CAC9D,AACD,yGAIA,QACI,mDAAsD,CACzD,CACA,AACD,yBACA,QACM,0BAA2B,AAC3B,oDAGC,CACN,AACD,2BACI,YAAc,CACjB,CACA","file":"Editor.vue","sourcesContent":["\n.editor {\n  display: grid;\n  grid-template-areas:\n    \"slides-toolbar   toolbox         inspector\"\n    \"slides-toolbar   current-slide   inspector\"\n    \"slides-toolbar   slide-controls  inspector\";\n  grid-template-columns: 250px minmax(300px, 1fr) 300px;\n  grid-template-rows: auto 1fr auto;\n  overflow: hidden;\n}\n@-webkit-keyframes slideInFromLeft {\n0% {\n    opacity: 0.5;\n    -webkit-transform: translateX(-100%);\n            transform: translateX(-100%);\n}\n100% {\n    opacity: 1;\n    -webkit-transform: translateX(0);\n            transform: translateX(0);\n}\n}\n@keyframes slideInFromLeft {\n0% {\n    opacity: 0.5;\n    -webkit-transform: translateX(-100%);\n            transform: translateX(-100%);\n}\n100% {\n    opacity: 1;\n    -webkit-transform: translateX(0);\n            transform: translateX(0);\n}\n}\n@-webkit-keyframes slideInFromRight {\n0% {\n    opacity: 0.5;\n    -webkit-transform: translateX(100%);\n            transform: translateX(100%);\n}\n100% {\n    opacity: 1;\n    -webkit-transform: translateX(0);\n            transform: translateX(0);\n}\n}\n@keyframes slideInFromRight {\n0% {\n    opacity: 0.5;\n    -webkit-transform: translateX(100%);\n            transform: translateX(100%);\n}\n100% {\n    opacity: 1;\n    -webkit-transform: translateX(0);\n            transform: translateX(0);\n}\n}\n@-webkit-keyframes slideInFromTop {\n0% {\n    opacity: 0.5;\n    -webkit-transform: translateY(-100%);\n            transform: translateY(-100%);\n}\n100% {\n    opacity: 1;\n    -webkit-transform: translateY(0);\n            transform: translateY(0);\n}\n}\n@keyframes slideInFromTop {\n0% {\n    opacity: 0.5;\n    -webkit-transform: translateY(-100%);\n            transform: translateY(-100%);\n}\n100% {\n    opacity: 1;\n    -webkit-transform: translateY(0);\n            transform: translateY(0);\n}\n}\n@-webkit-keyframes slideInFromBottom {\n0% {\n    opacity: 0.5;\n    -webkit-transform: translateY(100%);\n            transform: translateY(100%);\n}\n100% {\n    opacity: 1;\n    -webkit-transform: translateY(0);\n            transform: translateY(0);\n}\n}\n@keyframes slideInFromBottom {\n0% {\n    opacity: 0.5;\n    -webkit-transform: translateY(100%);\n            transform: translateY(100%);\n}\n100% {\n    opacity: 1;\n    -webkit-transform: translateY(0);\n            transform: translateY(0);\n}\n}\n@-webkit-keyframes scale {\n0% {\n    opacity: 0;\n    -webkit-transform: scale(0.5);\n            transform: scale(0.5);\n}\n100% {\n    opacity: 1;\n    -webkit-transform: scale(1);\n            transform: scale(1);\n}\n}\n@keyframes scale {\n0% {\n    opacity: 0;\n    -webkit-transform: scale(0.5);\n            transform: scale(0.5);\n}\n100% {\n    opacity: 1;\n    -webkit-transform: scale(1);\n            transform: scale(1);\n}\n}\n@-webkit-keyframes highlightFlash {\n0% {\n    opacity: 1;\n    width: 100%;\n}\n100% {\n    opacity: 0;\n    width: 0;\n}\n}\n@keyframes highlightFlash {\n0% {\n    opacity: 1;\n    width: 100%;\n}\n100% {\n    opacity: 0;\n    width: 0;\n}\n}\n.editor .slides-toolbar {\n  -webkit-animation: 0.4s ease-in-out 0.1s 1 slideInFromLeft;\n          animation: 0.4s ease-in-out 0.1s 1 slideInFromLeft;\n}\n.editor .current-slide {\n  -webkit-animation: 0.4s ease-in-out 0s 1 scale;\n          animation: 0.4s ease-in-out 0s 1 scale;\n}\n.editor .inspector {\n  -webkit-animation: 0.4s ease-in-out 0.1s 1 slideInFromRight;\n          animation: 0.4s ease-in-out 0.1s 1 slideInFromRight;\n}\n.editor .no-slides-message {\n  color: white;\n  font-size: 2em;\n  z-index: -10;\n  opacity: 0;\n  grid-row: 1 / -1;\n  grid-column: 2 / -1;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n\n  display: grid;\n  grid-gap: 1em;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  justify-items: center;\n  -ms-flex-line-pack: center;\n      align-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.editor .no-slides-message i {\n  padding: 0.5em;\n  border-radius: 100px;\n  border: 4px solid rgba(0, 0, 0, 0.2);\n}\n.editor.no-slides .no-slides-message {\n  -webkit-transition: 0.4s all;\n  transition: 0.4s all;\n  z-index: 5;\n  background-color: var(--dark-grey);\n  opacity: 0.9;\n}\n.inspector.changed::before {\n  content: \"\";\n  background-color: rgba(255, 255, 255, 0.1);\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  width: 0;\n  right: 0;\n  z-index: 5;\n  opacity: 0;\n  -webkit-animation: highlightFlash 0.7s;\n          animation: highlightFlash 0.7s;\n  -webkit-animation-iteration-count: 1;\n  animation-iteration-count: 1;\n}\n.editor .toolbox {\n  -webkit-animation: 0.4s ease-in-out 0.1s 1 slideInFromTop;\n          animation: 0.4s ease-in-out 0.1s 1 slideInFromTop;\n}\n.editor .slide-controls {\n  -webkit-animation: 0.4s ease-in-out 0.1s 1 slideInFromBottom;\n          animation: 0.4s ease-in-out 0.1s 1 slideInFromBottom;\n}\n@media only screen \n      and (device-width : 375px) \n      and (device-height : 812px) \n      and (-webkit-device-pixel-ratio : 3) {\n.editor {\n    grid-template-columns: 150px minmax(300px, 1fr) 150px;\n}\n}\n@media (max-width: 800px) {\n.editor {\n      grid-template-columns: 1fr;\n      grid-template-areas:\n      \"slide-controls\"\n      \"current-slide\"\n      ;\n}\n.editor .no-slides-message {\n    display: none;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 266:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (vm, socket) {
  socket.on('connect', function () {
    console.info('Connected to server socket');

    socket.emit('joined-room', {
      presentationId: vm.$route.params.presentationId,
      user: vm.current_user
    });
  });

  window.onbeforeunload = function () {
    return socket.emit('left-room');
  };

  socket.on('renamed-presentation', function (newTitle) {
    console.info('received a rename event');
    vm.updateTitle(newTitle);
  });

  socket.on('changed-slide-background-colour', function (_ref) {
    var slideIndex = _ref.slideIndex,
        slide = _ref.slide;

    console.info('Received a changed background colour event');
    vm.replaceSlide({ slideIndex: slideIndex, slide: slide });
  });

  socket.on('modified-elements', function (_ref2) {
    var slideIndex = _ref2.slideIndex,
        elements = _ref2.elements;

    console.info('received a modified-elements event');
    vm.setElements({ slideIndex: slideIndex, elements: elements });
  });

  socket.on('modified-slides', function (slides) {
    console.info('Received a modified-slides event');
    vm.setSlides(slides);
  });

  socket.on('refresh-users-list', function (usersList) {
    console.info('Received a refresh-users-list event');
    console.log(usersList);
    vm.setUsersList(usersList);
  });
});

/***/ }),

/***/ 267:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SlidesToolbar_vue__ = __webpack_require__(245);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f7bb46b8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SlidesToolbar_vue__ = __webpack_require__(270);
function injectStyle (ssrContext) {
  __webpack_require__(268)
}
var normalizeComponent = __webpack_require__(27)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SlidesToolbar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f7bb46b8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SlidesToolbar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 268:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(269);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(205)("06f52248", content, true, {});

/***/ }),

/***/ 269:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(204)(true);
// imports


// module
exports.push([module.i, ".slides-toolbar{grid-area:slides-toolbar;counter-reset:slides-counter;background-color:var(--medium-grey);-webkit-box-shadow:5px 0 5px rgba(0,0,0,.2);box-shadow:5px 0 5px rgba(0,0,0,.2);z-index:1;overflow-x:hidden;overflow-y:scroll;display:grid;grid-template-columns:1fr;grid-template-rows:auto 1fr}.slides-toolbar ul{list-style:none}.slides-toolbar ul.actions{display:grid;-webkit-box-align:center;-ms-flex-align:center;align-items:center;justify-items:end;grid-gap:1em;background-color:rgba(0,0,0,.4)}.slides-toolbar ul.actions li{display:grid;grid-template:1fr/1fr}.slides-toolbar ul.actions li a{background-color:rgba(0,0,0,.4);display:grid;grid-gap:1em;grid-template-columns:auto 1fr;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;padding:.5em 1em;font-weight:700}.slides-toolbar ul.actions li a i{font-size:1.2em}.slides-toolbar ul.actions li a:hover{background-color:rgba(0,0,0,.6);-webkit-transition:background-color .2s;transition:background-color .2s}.slides-toolbar ul.slides{display:grid;grid-gap:1em;padding:1em;grid-template-columns:1fr;-webkit-box-align:start;-ms-flex-align:start;align-items:start;-ms-flex-line-pack:start;align-content:start;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:start}.slides-toolbar ul.slides li{color:var(--dark-grey);border-radius:5px;padding:.5em;height:120px;position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}.slides-toolbar ul.slides li.dragging-over{opacity:.5;-webkit-transform:scale(.7);transform:scale(.7);-webkit-transition:all .4s;transition:all .4s}.slides-toolbar ul.slides li.dragging-over:before{content:\"\";z-index:4;background-color:rgba(0,0,0,.4);position:absolute;top:0;right:0;bottom:0;left:0}.slides-toolbar ul.slides li a.preview{background-color:#fff;position:relative;width:calc(100% - 2em - 6px);border:3px solid var(--dark-grey);cursor:default;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-user-select:none;-ms-user-select:none;user-select:none;-moz-user-select:none}.slides-toolbar ul.slides li a.preview:before{counter-increment:slides-counter;content:counter(slides-counter);position:absolute;top:0;left:calc(-2em - 6px);width:2em;height:1.5em;text-align:center;color:#fff;font-weight:700;cursor:move}.slides-toolbar ul.slides li:hover a.delete{-webkit-transition:all .2s;transition:all .2s;visibility:visible;opacity:1}.slides-toolbar ul.slides li a.delete{visibility:hidden;opacity:0;background-color:rgba(0,0,0,.7);color:#fff;position:absolute;bottom:1em;right:1em;width:auto;border:0;padding:.3em .5em;font-size:.7em;border-top-left-radius:3px;cursor:pointer;display:grid;grid-gap:.5em;grid-template-columns:auto 1fr;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.slides-toolbar ul.slides li a.delete i{font-size:1.6em}.slides-toolbar ul.slides li a.delete span{text-transform:uppercase;font-weight:700}.slides-toolbar ul.slides li:hover{background-color:rgba(0,0,0,.2)}.slides-toolbar ul.slides li.selected{background-color:rgba(0,0,0,.1)}.slides-toolbar ul.slides li.selected a.preview{border-color:var(--primary-colour)}.slides-toolbar ul.slides .slides-list-enter-active,.slides-toolbar ul.slides .slides-list-leave-active{-webkit-transition:all .3s;transition:all .3s}.slides-toolbar ul.slides .slides-list-enter,.slides-toolbar ul.slides .slides-list-leave-to{opacity:0;-webkit-transform:scale(.5);transform:scale(.5)}.slides-toolbar ul.slides .slides-list-move{-webkit-transition:-webkit-transform .4s;transition:-webkit-transform .4s;transition:transform .4s;transition:transform .4s,-webkit-transform .4s}@media only screen and (device-width:375px) and (device-height:812px) and (-webkit-device-pixel-ratio:3){.slides-toolbar{padding-left:env(safe-area-inset-left);overflow-y:scroll}.slides-toolbar ul.slides li{height:62px;padding:0}.slides-toolbar ul.slides li a.preview{width:100%;height:100%;border-width:4px}.slides-toolbar ul.slides li a.preview:before{display:none}}@media (max-width:800px){.slides-toolbar{display:none}}", "", {"version":3,"sources":["/home/forge/slidekick.daniel-waghorn.com/src/components/SlidesToolbar.vue"],"names":[],"mappings":"AACA,gBACE,yBAA0B,AAC1B,6BAA8B,AAE9B,oCAAqC,AACrC,4CAAiD,AACzC,oCAAyC,AACjD,UAAW,AACX,kBAAmB,AACnB,kBAAmB,AAEnB,aAAc,AAEd,0BAA2B,AAC3B,2BAA6B,CAC9B,AACD,mBACE,eAAiB,CAClB,AACD,2BACE,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,kBAAmB,AACnB,aAAc,AACd,+BAAqC,CACtC,AACD,8BACE,aAAc,AACd,qBAAyB,CAC1B,AACD,gCACE,gCAAqC,AACrC,aAAc,AACd,aAAc,AACd,+BAAgC,AAChC,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,yBAA0B,AACtB,sBAAuB,AACnB,8BAA+B,AACvC,iBAAmB,AACnB,eAAkB,CACnB,AACD,kCACE,eAAiB,CAClB,AACD,sCACE,gCAAqC,AACrC,wCAA0C,AAC1C,+BAAkC,CACnC,AACD,0BACE,aAAc,AACd,aAAc,AACd,YAAa,AAEb,0BAA2B,AAC3B,wBAAyB,AACrB,qBAAsB,AAClB,kBAAmB,AAC3B,yBAA0B,AACtB,oBAAqB,AACzB,uBAAwB,AACpB,oBAAqB,AACjB,qBAAuB,CAChC,AACD,6BACE,uBAAwB,AACxB,kBAAmB,AACnB,aAAe,AACf,aAAc,AACd,kBAAmB,AAEnB,oBAAqB,AAErB,oBAAqB,AAErB,aAAc,AACd,qBAAsB,AAClB,kBAAmB,AACf,wBAA0B,CACnC,AACD,2CACE,WAAa,AACb,4BAA8B,AACtB,oBAAsB,AAC9B,2BAA6B,AAC7B,kBAAqB,CACtB,AACD,kDACE,WAAY,AACZ,UAAW,AACX,gCAAqC,AACrC,kBAAmB,AACnB,MAAO,AACP,QAAS,AACT,SAAU,AACV,MAAQ,CACT,AACD,uCACE,sBAAwB,AACxB,kBAAmB,AACnB,6BAA8B,AAC9B,kCAAmC,AACnC,eAAgB,AAEhB,oBAAqB,AAErB,oBAAqB,AAErB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAEhC,yBAA0B,AAEtB,qBAAsB,AAElB,iBAAkB,AAC1B,qBAAuB,CACxB,AACD,8CACE,iCAAkC,AAClC,gCAAiC,AAEjC,kBAAmB,AACnB,MAAO,AACP,sBAAuB,AACvB,UAAW,AACX,aAAc,AAEd,kBAAmB,AACnB,WAAa,AACb,gBAAkB,AAClB,WAAa,CACd,AACD,4CACE,2BAA6B,AAC7B,mBAAqB,AACrB,mBAAoB,AACpB,SAAW,CACZ,AACD,sCACE,kBAAmB,AACnB,UAAW,AACX,gCAAqC,AACrC,WAAa,AACb,kBAAmB,AACnB,WAAY,AACZ,UAAW,AACX,WAAY,AACZ,SAAU,AACV,kBAAqB,AACrB,eAAiB,AACjB,2BAA4B,AAC5B,eAAgB,AAEhB,aAAc,AACd,cAAgB,AAChB,+BAAgC,AAChC,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,yBAA0B,AACtB,sBAAuB,AACnB,6BAA+B,CACxC,AACD,wCACE,eAAiB,CAClB,AACD,2CACE,yBAA0B,AAC1B,eAAkB,CACnB,AACD,mCACE,+BAAqC,CACtC,AACD,sCACE,+BAAqC,CACtC,AACD,gDACE,kCAAoC,CACrC,AACD,wGAEE,2BAA6B,AAC7B,kBAAqB,CACtB,AACD,6FAEE,UAAW,AACX,4BAA8B,AACtB,mBAAsB,CAC/B,AACD,4CACE,yCAA2C,AAC3C,iCAAmC,AACnC,yBAA2B,AAC3B,8CAAmD,CACpD,AACD,yGAIA,gBACI,uCAAwC,AACxC,iBAAmB,CACtB,AACD,6BACI,YAAa,AACb,SAAW,CACd,AACD,uCACI,WAAY,AACZ,YAAa,AACb,gBAAkB,CACrB,AACD,8CACI,YAAc,CACjB,CACA,AACD,yBACA,gBACI,YAAc,CACjB,CACA","file":"SlidesToolbar.vue","sourcesContent":["\n.slides-toolbar {\n  grid-area: slides-toolbar;\n  counter-reset: slides-counter;\n  \n  background-color: var(--medium-grey);\n  -webkit-box-shadow: 5px 0 5px rgba(0, 0, 0, 0.2);\n          box-shadow: 5px 0 5px rgba(0, 0, 0, 0.2);\n  z-index: 1;\n  overflow-x: hidden;\n  overflow-y: scroll;\n  \n  display: grid;\n  \n  grid-template-columns: 1fr;\n  grid-template-rows: auto 1fr;\n}\n.slides-toolbar ul {\n  list-style: none;\n}\n.slides-toolbar ul.actions {\n  display: grid;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  justify-items: end;\n  grid-gap: 1em;\n  background-color: rgba(0, 0, 0, 0.4);\n}\n.slides-toolbar ul.actions li {\n  display: grid;\n  grid-template: 1fr / 1fr;\n}\n.slides-toolbar ul.actions li a {\n  background-color: rgba(0, 0, 0, 0.4);\n  display: grid;\n  grid-gap: 1em;\n  grid-template-columns: auto 1fr;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  padding: 0.5em 1em;\n  font-weight: bold;\n}\n.slides-toolbar ul.actions li a i {\n  font-size: 1.2em;\n}\n.slides-toolbar ul.actions li a:hover {\n  background-color: rgba(0, 0, 0, 0.6);\n  -webkit-transition: 0.2s background-color;\n  transition: 0.2s background-color;\n}\n.slides-toolbar ul.slides {\n  display: grid;\n  grid-gap: 1em;\n  padding: 1em;\n  \n  grid-template-columns: 1fr;\n  -webkit-box-align: start;\n      -ms-flex-align: start;\n          align-items: start;\n  -ms-flex-line-pack: start;\n      align-content: start;\n  -webkit-box-pack: start;\n      -ms-flex-pack: start;\n          justify-content: start;\n}\n.slides-toolbar ul.slides li {\n  color: var(--dark-grey);\n  border-radius: 5px;\n  padding: 0.5em;\n  height: 120px;\n  position: relative;\n  \n  display: -webkit-box;\n  \n  display: -ms-flexbox;\n  \n  display: flex;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n}\n.slides-toolbar ul.slides li.dragging-over {\n  opacity: 0.5;\n  -webkit-transform: scale(0.7);\n          transform: scale(0.7);\n  -webkit-transition: 0.4s all;\n  transition: 0.4s all;\n}\n.slides-toolbar ul.slides li.dragging-over::before {\n  content: '';\n  z-index: 4;\n  background-color: rgba(0, 0, 0, 0.4);\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n}\n.slides-toolbar ul.slides li a.preview {\n  background-color: white;\n  position: relative;\n  width: calc(100% - 2em - 6px);\n  border: 3px solid var(--dark-grey);\n  cursor: default;\n  \n  display: -webkit-box;\n  \n  display: -ms-flexbox;\n  \n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  \n  -webkit-user-select: none;\n  \n      -ms-user-select: none;\n  \n          user-select: none;\n  -moz-user-select: none;\n}\n.slides-toolbar ul.slides li a.preview::before {\n  counter-increment: slides-counter;\n  content: counter(slides-counter);\n  \n  position: absolute;\n  top: 0;\n  left: calc(-2em - 6px);\n  width: 2em;\n  height: 1.5em;\n  \n  text-align: center;\n  color: white;\n  font-weight: bold;\n  cursor: move;\n}\n.slides-toolbar ul.slides li:hover a.delete {\n  -webkit-transition: 0.2s all;\n  transition: 0.2s all;\n  visibility: visible;\n  opacity: 1;\n}\n.slides-toolbar ul.slides li a.delete {\n  visibility: hidden;\n  opacity: 0;\n  background-color: rgba(0, 0,0 , 0.7);\n  color: white;\n  position: absolute;\n  bottom: 1em;\n  right: 1em;\n  width: auto;\n  border: 0;\n  padding: 0.3em 0.5em;\n  font-size: 0.7em;\n  border-top-left-radius: 3px;\n  cursor: pointer;\n\n  display: grid;\n  grid-gap: 0.5em;\n  grid-template-columns: auto 1fr;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.slides-toolbar ul.slides li a.delete i {\n  font-size: 1.6em;\n}\n.slides-toolbar ul.slides li a.delete span {\n  text-transform: uppercase;\n  font-weight: bold;\n}\n.slides-toolbar ul.slides li:hover {\n  background-color: rgba(0, 0, 0, 0.2);\n}\n.slides-toolbar ul.slides li.selected {\n  background-color: rgba(0, 0, 0, 0.1);\n}\n.slides-toolbar ul.slides li.selected a.preview {\n  border-color: var(--primary-colour);\n}\n.slides-toolbar ul.slides .slides-list-enter-active,\n.slides-toolbar ul.slides .slides-list-leave-active {\n  -webkit-transition: all 0.3s;\n  transition: all 0.3s;\n}\n.slides-toolbar ul.slides .slides-list-enter,\n.slides-toolbar ul.slides .slides-list-leave-to {\n  opacity: 0;\n  -webkit-transform: scale(0.5);\n          transform: scale(0.5);\n}\n.slides-toolbar ul.slides .slides-list-move {\n  -webkit-transition: -webkit-transform 0.4s;\n  transition: -webkit-transform 0.4s;\n  transition: transform 0.4s;\n  transition: transform 0.4s, -webkit-transform 0.4s;\n}\n@media only screen \n      and (device-width : 375px) \n      and (device-height : 812px) \n      and (-webkit-device-pixel-ratio : 3) {\n.slides-toolbar {\n    padding-left: env(safe-area-inset-left);\n    overflow-y: scroll;\n}\n.slides-toolbar ul.slides li {\n    height: 62px;\n    padding: 0;\n}\n.slides-toolbar ul.slides li a.preview {\n    width: 100%;\n    height: 100%;\n    border-width: 4px;\n}\n.slides-toolbar ul.slides li a.preview::before {\n    display: none;\n}\n}\n@media (max-width: 800px) {\n.slides-toolbar {\n    display: none;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 270:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"slides-toolbar"},[_c('ul',{staticClass:"actions"},[_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":_vm.createSlide}},[_c('i',{staticClass:"material-icons"},[_vm._v("library_add")]),_vm._v(" "),_c('span',[_vm._v("New slide")])])])]),_vm._v(" "),_c('transition-group',{staticClass:"slides",attrs:{"tag":"ul","name":"slides-list"}},_vm._l((_vm.slides),function(slide,i){return _c('li',{key:i,class:{'selected': _vm.selectedSlideIndex === i, 'dragging-over': _vm.draggingSlideIndex !== i && _vm.replaceSlideIndex === i},attrs:{"draggable":"true"},on:{"dragstart":function($event){_vm.dragstart(i)},"dragover":function($event){$event.preventDefault();_vm.dragover(i)},"dragend":function($event){$event.preventDefault();_vm.dragend($event)}}},[_c('a',{staticClass:"preview",attrs:{"href":"#"},on:{"click":function($event){_vm.selectSlideFromList(i)}}},[_vm._v("\n        [slide "+_vm._s(i + 1)+"]\n      ")]),_vm._v(" "),_c('a',{staticClass:"delete",attrs:{"href":"#"},on:{"click":function($event){_vm.deleteSlide(i)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("delete")]),_vm._v(" "),_c('span',[_vm._v("Delete")])])])}))],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 271:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Toolbox_vue__ = __webpack_require__(246);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d218bd3_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Toolbox_vue__ = __webpack_require__(274);
function injectStyle (ssrContext) {
  __webpack_require__(272)
}
var normalizeComponent = __webpack_require__(27)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Toolbox_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d218bd3_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Toolbox_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 272:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(273);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(205)("28cc836c", content, true, {});

/***/ }),

/***/ 273:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(204)(true);
// imports


// module
exports.push([module.i, ".toolbox{grid-area:toolbox;background-color:rgba(0,0,0,.4);list-style:none;z-index:2;padding:.5em;display:grid;grid-gap:1em;grid-template-columns:repeat(2,1fr);justify-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.toolbox li a{padding:.7em;display:grid;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;grid-gap:1em;grid-template-columns:auto 1fr;border-radius:5px}.toolbox li:hover a,.toolbox li a:hover{background-color:rgba(0,0,0,.5)}@media (max-width:800px){.toolbox{display:none}}", "", {"version":3,"sources":["/home/forge/slidekick.daniel-waghorn.com/src/components/Toolbox.vue"],"names":[],"mappings":"AACA,SACE,kBAAmB,AACnB,gCAAqC,AACrC,gBAAiB,AACjB,UAAW,AACX,aAAe,AAEf,aAAc,AACd,aAAc,AACd,oCAAsC,AACtC,qBAAsB,AACtB,wBAAyB,AACrB,qBAAsB,AAClB,sBAAwB,CACjC,AACD,cACE,aAAe,AAEf,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,yBAA0B,AACtB,sBAAuB,AACnB,8BAA+B,AACvC,aAAc,AACd,+BAAgC,AAChC,iBAAmB,CACpB,AACD,wCAEE,+BAAqC,CACtC,AACD,yBACA,SACI,YAAc,CACjB,CACA","file":"Toolbox.vue","sourcesContent":["\n.toolbox {\n  grid-area: toolbox;\n  background-color: rgba(0, 0, 0, 0.4);\n  list-style: none;\n  z-index: 2;\n  padding: 0.5em;\n  \n  display: grid;\n  grid-gap: 1em;\n  grid-template-columns: repeat(2, 1fr);\n  justify-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.toolbox li a {\n  padding: 0.7em;\n\n  display: grid;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  grid-gap: 1em;\n  grid-template-columns: auto 1fr;\n  border-radius: 5px;\n}\n.toolbox li:hover a,\n.toolbox li a:hover {\n  background-color: rgba(0, 0, 0, 0.5);\n}\n@media (max-width: 800px) {\n.toolbox {\n    display: none;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 274:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"toolbox"},[_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":_vm.createText}},[_c('i',{staticClass:"material-icons"},[_vm._v("text_fields")]),_vm._v(" "),_c('span',[_vm._v("New text")])])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":_vm.createImage}},[_c('i',{staticClass:"material-icons"},[_vm._v("photo")]),_vm._v(" "),_c('span',[_vm._v("New image")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 275:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Inspector_vue__ = __webpack_require__(247);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2fcdc68c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Inspector_vue__ = __webpack_require__(283);
function injectStyle (ssrContext) {
  __webpack_require__(276)
}
var normalizeComponent = __webpack_require__(27)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Inspector_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2fcdc68c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Inspector_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 276:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(277);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(205)("c9728204", content, true, {});

/***/ }),

/***/ 277:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(204)(true);
// imports


// module
exports.push([module.i, ".inspector{grid-area:inspector;background-color:var(--medium-grey);-webkit-box-shadow:-5px 0 5px rgba(0,0,0,.2);box-shadow:-5px 0 5px rgba(0,0,0,.2);z-index:1;position:relative;overflow-y:scroll;-webkit-box-align:start;-ms-flex-align:start;align-items:start;justify-items:stretch;-ms-flex-line-pack:start;align-content:start;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:start}.inspector,.inspector .section{display:grid;grid-template-columns:1fr;grid-template-rows:auto}.inspector .section.hidden .options{height:0;opacity:0;padding:0;-webkit-transform:translateY(-100%);transform:translateY(-100%);visibility:hidden;-webkit-transition:opacity transform .4s;transition:opacity transform .4s}.inspector .section.hidden .header a i{-webkit-transform:rotate(180deg);transform:rotate(180deg);-webkit-transition:all .4s;transition:all .4s}.inspector .section .header{background-color:rgba(0,0,0,.2);color:hsla(0,0%,100%,.9);font-size:.9em;display:grid;grid-gap:1em;grid-template-columns:1fr auto;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.inspector .section .header a:first-child{font-weight:700;-webkit-user-select:none;-ms-user-select:none;user-select:none;-moz-user-select:none}.inspector .section .header a{padding:.3em .7em}.inspector .section .header a:last-child{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.inspector .section .header a:last-child:hover{background-color:rgba(0,0,0,.2)}.inspector .section .options{padding:1em;display:grid;grid-gap:1em;grid-template-columns:repeat(2,1fr);-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:stretch;-ms-flex-pack:stretch;justify-content:stretch}.inspector .section .options>.colour-picker input,.inspector .section .options>:not(label):not(.colour-picker){width:100%;background-color:#fff;padding:.5em .7em;border:0;outline:2px solid rgba(0,0,0,.2);border-radius:0}.inspector .section .options>.colour-picker input:focus,.inspector .section .options>:not(label):not(.colour-picker):focus{outline-color:rgba(0,0,0,.4)}.delete{margin:1em;padding:.8em 1em;border-radius:5px;background-color:#f33;display:grid;grid-template-columns:auto 1fr;grid-gap:1em;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.delete:hover{background-color:#ff1a1a}@media only screen and (device-width:375px) and (device-height:812px) and (-webkit-device-pixel-ratio:3){.inspector{max-height:100%;overflow-x:visible;overflow-y:scroll}.inspector .section .options{padding-right:env(safe-area-inset-right)!important;grid-template-columns:1fr}.inspector .section .header a:last-child{visibility:hidden}}@media (max-width:800px){.inspector{display:none}}", "", {"version":3,"sources":["/home/forge/slidekick.daniel-waghorn.com/src/components/Inspector.vue"],"names":[],"mappings":"AACA,WACE,oBAAqB,AAErB,oCAAqC,AACrC,6CAAkD,AAC1C,qCAA0C,AAClD,UAAW,AACX,kBAAmB,AACnB,kBAAmB,AAKnB,wBAAyB,AACrB,qBAAsB,AAClB,kBAAmB,AAC3B,sBAAuB,AACvB,yBAA0B,AACtB,oBAAqB,AACzB,uBAAwB,AACpB,oBAAqB,AACjB,qBAAuB,CAChC,AACD,+BAbE,aAAc,AACd,0BAA2B,AAC3B,uBAAyB,CAe1B,AACD,oCACE,SAAU,AACV,UAAW,AACX,UAAW,AACX,oCAAqC,AAC7B,4BAA6B,AACrC,kBAAmB,AACnB,yCAA2C,AAC3C,gCAAmC,CACpC,AACD,uCACE,iCAAkC,AAC1B,yBAA0B,AAClC,2BAA6B,AAC7B,kBAAqB,CACtB,AACD,4BACE,gCAAqC,AACrC,yBAAgC,AAChC,eAAiB,AAEjB,aAAc,AACd,aAAc,AACd,+BAAgC,AAChC,yBAA0B,AACtB,sBAAuB,AACnB,kBAAoB,CAC7B,AACD,0CACE,gBAAkB,AAClB,yBAA0B,AACtB,qBAAsB,AAClB,iBAAkB,AAC1B,qBAAuB,CACxB,AACD,8BACE,iBAAqB,CACtB,AACD,yCACE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,wBAAyB,AACrB,qBAAsB,AAClB,sBAAwB,CACjC,AACD,+CACE,+BAAqC,CACtC,AACD,6BACE,YAAa,AAEb,aAAc,AACd,aAAc,AACd,oCAAsC,AACtC,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,yBAA0B,AACtB,sBAAuB,AACnB,uBAAyB,CAClC,AACD,+GAEE,WAAY,AACZ,sBAAwB,AACxB,kBAAqB,AACrB,SAAU,AACV,iCAAsC,AACtC,eAAiB,CAClB,AACD,2HAEE,4BAAkC,CACnC,AACD,QACE,WAAY,AACZ,iBAAmB,AACnB,kBAAmB,AAEnB,sBAAoC,AACpC,aAAc,AACd,+BAAgC,AAChC,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,kBAAoB,CAC7B,AACD,cACE,wBAAoC,CACrC,AACD,yGAIA,WACI,gBAAiB,AACjB,mBAAoB,AACpB,iBAAmB,CACtB,AACD,6BACI,mDAAqD,AACrD,yBAA2B,CAC9B,AACD,yCACI,iBAAmB,CACtB,CACA,AACD,yBACA,WACI,YAAc,CACjB,CACA","file":"Inspector.vue","sourcesContent":["\n.inspector {\n  grid-area: inspector;\n  \n  background-color: var(--medium-grey);\n  -webkit-box-shadow: -5px 0 5px rgba(0, 0, 0, 0.2);\n          box-shadow: -5px 0 5px rgba(0, 0, 0, 0.2);\n  z-index: 1;\n  position: relative;\n  overflow-y: scroll;\n  \n  display: grid;\n  grid-template-columns: 1fr;\n  grid-template-rows: auto;\n  -webkit-box-align: start;\n      -ms-flex-align: start;\n          align-items: start;\n  justify-items: stretch;\n  -ms-flex-line-pack: start;\n      align-content: start;\n  -webkit-box-pack: start;\n      -ms-flex-pack: start;\n          justify-content: start;\n}\n.inspector .section {\n  display: grid;\n  grid-template-columns: 1fr;\n  grid-template-rows: auto;\n}\n.inspector .section.hidden .options {\n  height: 0;\n  opacity: 0;\n  padding: 0;\n  -webkit-transform: translateY(-100%);\n          transform: translateY(-100%);\n  visibility: hidden;\n  -webkit-transition: 0.4s opacity transform;\n  transition: 0.4s opacity transform;\n}\n.inspector .section.hidden .header a i {\n  -webkit-transform: rotate(180deg);\n          transform: rotate(180deg);\n  -webkit-transition: 0.4s all;\n  transition: 0.4s all;\n}\n.inspector .section .header {\n  background-color: rgba(0, 0, 0, 0.2);\n  color: rgba(255, 255, 255, 0.9);\n  font-size: 0.9em;\n  \n  display: grid;\n  grid-gap: 1em;\n  grid-template-columns: 1fr auto;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.inspector .section .header a:first-child {\n  font-weight: bold;\n  -webkit-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  -moz-user-select: none;\n}\n.inspector .section .header a {\n  padding: 0.3em 0.7em;\n}\n.inspector .section .header a:last-child {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.inspector .section .header a:last-child:hover {\n  background-color: rgba(0, 0, 0, 0.2);\n}\n.inspector .section .options {\n  padding: 1em;\n  \n  display: grid;\n  grid-gap: 1em;\n  grid-template-columns: repeat(2, 1fr);\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: stretch;\n      -ms-flex-pack: stretch;\n          justify-content: stretch;\n}\n.inspector .section .options > :not(label):not(.colour-picker),\n.inspector .section .options > .colour-picker input {\n  width: 100%;\n  background-color: white;\n  padding: 0.5em 0.7em;\n  border: 0;\n  outline: 2px solid rgba(0, 0, 0, 0.2);\n  border-radius: 0;\n}\n.inspector .section .options > :not(label):not(.colour-picker):focus,\n.inspector .section .options > .colour-picker input:focus {\n  outline-color: rgba(0, 0, 0, 0.4);\n}\n.delete {\n  margin: 1em;\n  padding: 0.8em 1em;\n  border-radius: 5px;\n\n  background-color: hsl(0, 100%, 60%);\n  display: grid;\n  grid-template-columns: auto 1fr;\n  grid-gap: 1em;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.delete:hover {\n  background-color: hsl(0, 100%, 55%);\n}\n@media only screen \n      and (device-width : 375px) \n      and (device-height : 812px) \n      and (-webkit-device-pixel-ratio : 3) {\n.inspector {\n    max-height: 100%;\n    overflow-x: visible;\n    overflow-y: scroll;\n}\n.inspector .section .options {\n    padding-right: env(safe-area-inset-right) !important;\n    grid-template-columns: 1fr;\n}\n.inspector .section .header a:last-child {\n    visibility: hidden;\n}\n}\n@media (max-width: 800px) {\n.inspector {\n    display: none;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 278:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ColourPicker_vue__ = __webpack_require__(248);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eed05da4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ColourPicker_vue__ = __webpack_require__(282);
function injectStyle (ssrContext) {
  __webpack_require__(279)
}
var normalizeComponent = __webpack_require__(27)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-eed05da4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ColourPicker_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eed05da4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ColourPicker_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 279:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(280);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(205)("2f4b3d5c", content, true, {});

/***/ }),

/***/ 280:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(204)(true);
// imports


// module
exports.push([module.i, ".colour-picker[data-v-eed05da4]{display:grid;grid-template-areas:\"input preview\";position:relative}.colour-picker input[data-v-eed05da4]{grid-area:input;grid-column:1/-1}.colour-picker .preview[data-v-eed05da4]{grid-area:preview;cursor:pointer;padding:8px;border-radius:10px;margin:5px;z-index:2;-webkit-box-shadow:inset 0 0 1px rgba(0,0,0,.4);box-shadow:inset 0 0 1px rgba(0,0,0,.4)}.colour-picker .picker[data-v-eed05da4]{position:absolute;top:calc(100% + 10px);right:0}", "", {"version":3,"sources":["/home/forge/slidekick.daniel-waghorn.com/src/components/ColourPicker.vue"],"names":[],"mappings":"AACA,gCACE,aAAc,AACd,oCAAqC,AACrC,iBAAmB,CACpB,AACD,sCACE,gBAAiB,AACjB,gBAAoB,CACrB,AACD,yCACE,kBAAmB,AACnB,eAAgB,AAChB,YAAa,AACb,mBAAoB,AACpB,WAAY,AACZ,UAAW,AACX,gDAAqD,AAC7C,uCAA6C,CACtD,AACD,wCACE,kBAAmB,AACnB,sBAAuB,AACvB,OAAS,CACV","file":"ColourPicker.vue","sourcesContent":["\n.colour-picker[data-v-eed05da4] {\n  display: grid;\n  grid-template-areas: \"input preview\";\n  position: relative;\n}\n.colour-picker input[data-v-eed05da4] {\n  grid-area: input;\n  grid-column: 1 / -1;\n}\n.colour-picker .preview[data-v-eed05da4] {\n  grid-area: preview;\n  cursor: pointer;\n  padding: 8px;\n  border-radius: 10px;\n  margin: 5px;\n  z-index: 2;\n  -webkit-box-shadow: inset 0 0 1px rgba(0, 0, 0, 0.4);\n          box-shadow: inset 0 0 1px rgba(0, 0, 0, 0.4);\n}\n.colour-picker .picker[data-v-eed05da4] {\n  position: absolute;\n  top: calc(100% + 10px);\n  right: 0;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 281:
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define([],t):"object"==typeof exports?exports.VueColor=t():e.VueColor=t()}(this,function(){return function(e){function t(r){if(n[r])return n[r].exports;var a=n[r]={i:r,l:!1,exports:{}};return e[r].call(a.exports,a,a.exports,t),a.l=!0,a.exports}var n={};return t.m=e,t.c=n,t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:r})},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="",t(t.s=22)}([function(e,t){function n(e,t){var n=e[1]||"",a=e[3];if(!a)return n;if(t&&"function"==typeof btoa){var i=r(a);return[n].concat(a.sources.map(function(e){return"/*# sourceURL="+a.sourceRoot+e+" */"})).concat([i]).join("\n")}return[n].join("\n")}function r(e){return"/*# sourceMappingURL=data:application/json;charset=utf-8;base64,"+btoa(unescape(encodeURIComponent(JSON.stringify(e))))+" */"}e.exports=function(e){var t=[];return t.toString=function(){return this.map(function(t){var r=n(t,e);return t[2]?"@media "+t[2]+"{"+r+"}":r}).join("")},t.i=function(e,n){"string"==typeof e&&(e=[[null,e,""]]);for(var r={},a=0;a<this.length;a++){var i=this[a][0];"number"==typeof i&&(r[i]=!0)}for(a=0;a<e.length;a++){var o=e[a];"number"==typeof o[0]&&r[o[0]]||(n&&!o[2]?o[2]=n:n&&(o[2]="("+o[2]+") and ("+n+")"),t.push(o))}},t}},function(e,t,n){function r(e){for(var t=0;t<e.length;t++){var n=e[t],r=u[n.id];if(r){r.refs++;for(var a=0;a<r.parts.length;a++)r.parts[a](n.parts[a]);for(;a<n.parts.length;a++)r.parts.push(i(n.parts[a]));r.parts.length>n.parts.length&&(r.parts.length=n.parts.length)}else{for(var o=[],a=0;a<n.parts.length;a++)o.push(i(n.parts[a]));u[n.id]={id:n.id,refs:1,parts:o}}}}function a(){var e=document.createElement("style");return e.type="text/css",d.appendChild(e),e}function i(e){var t,n,r=document.querySelector('style[data-vue-ssr-id~="'+e.id+'"]');if(r){if(p)return v;r.parentNode.removeChild(r)}if(g){var i=f++;r=h||(h=a()),t=o.bind(null,r,i,!1),n=o.bind(null,r,i,!0)}else r=a(),t=s.bind(null,r),n=function(){r.parentNode.removeChild(r)};return t(e),function(r){if(r){if(r.css===e.css&&r.media===e.media&&r.sourceMap===e.sourceMap)return;t(e=r)}else n()}}function o(e,t,n,r){var a=n?"":r.css;if(e.styleSheet)e.styleSheet.cssText=b(t,a);else{var i=document.createTextNode(a),o=e.childNodes;o[t]&&e.removeChild(o[t]),o.length?e.insertBefore(i,o[t]):e.appendChild(i)}}function s(e,t){var n=t.css,r=t.media,a=t.sourceMap;if(r&&e.setAttribute("media",r),a&&(n+="\n/*# sourceURL="+a.sources[0]+" */",n+="\n/*# sourceMappingURL=data:application/json;base64,"+btoa(unescape(encodeURIComponent(JSON.stringify(a))))+" */"),e.styleSheet)e.styleSheet.cssText=n;else{for(;e.firstChild;)e.removeChild(e.firstChild);e.appendChild(document.createTextNode(n))}}var c="undefined"!=typeof document;if("undefined"!=typeof DEBUG&&DEBUG&&!c)throw new Error("vue-style-loader cannot be used in a non-browser environment. Use { target: 'node' } in your Webpack config to indicate a server-rendering environment.");var l=n(26),u={},d=c&&(document.head||document.getElementsByTagName("head")[0]),h=null,f=0,p=!1,v=function(){},g="undefined"!=typeof navigator&&/msie [6-9]\b/.test(navigator.userAgent.toLowerCase());e.exports=function(e,t,n){p=n;var a=l(e,t);return r(a),function(t){for(var n=[],i=0;i<a.length;i++){var o=a[i],s=u[o.id];s.refs--,n.push(s)}t?(a=l(e,t),r(a)):a=[];for(var i=0;i<n.length;i++){var s=n[i];if(0===s.refs){for(var c=0;c<s.parts.length;c++)s.parts[c]();delete u[s.id]}}}};var b=function(){var e=[];return function(t,n){return e[t]=n,e.filter(Boolean).join("\n")}}()},function(e,t){e.exports=function(e,t,n,r,a,i){var o,s=e=e||{},c=typeof e.default;"object"!==c&&"function"!==c||(o=e,s=e.default);var l="function"==typeof s?s.options:s;t&&(l.render=t.render,l.staticRenderFns=t.staticRenderFns,l._compiled=!0),n&&(l.functional=!0),a&&(l._scopeId=a);var u;if(i?(u=function(e){e=e||this.$vnode&&this.$vnode.ssrContext||this.parent&&this.parent.$vnode&&this.parent.$vnode.ssrContext,e||"undefined"==typeof __VUE_SSR_CONTEXT__||(e=__VUE_SSR_CONTEXT__),r&&r.call(this,e),e&&e._registeredComponents&&e._registeredComponents.add(i)},l._ssrRegister=u):r&&(u=r),u){var d=l.functional,h=d?l.render:l.beforeCreate;d?(l._injectStyles=u,l.render=function(e,t){return u.call(t),h(e,t)}):l.beforeCreate=h?[].concat(h,u):[u]}return{esModule:o,exports:s,options:l}}},function(e,t,n){"use strict";function r(e,t){var n,r=e&&e.a;!(n=e&&e.hsl?(0,i.default)(e.hsl):e&&e.hex&&e.hex.length>0?(0,i.default)(e.hex):(0,i.default)(e))||void 0!==n._a&&null!==n._a||n.setAlpha(r||1);var a=n.toHsl(),o=n.toHsv();return 0===a.s&&(o.h=a.h=e.h||e.hsl&&e.hsl.h||t||0),{hsl:a,hex:n.toHexString().toUpperCase(),rgba:n.toRgb(),hsv:o,oldHue:e.h||t||a.h,source:e.source,a:e.a||n.getAlpha()}}Object.defineProperty(t,"__esModule",{value:!0});var a=n(27),i=function(e){return e&&e.__esModule?e:{default:e}}(a);t.default={props:["value"],data:function(){return{val:r(this.value)}},computed:{colors:{get:function(){return this.val},set:function(e){this.val=e,this.$emit("input",e)}}},watch:{value:function(e){this.val=r(e)}},methods:{colorChange:function(e,t){this.oldHue=this.colors.hsl.h,this.colors=r(e,t||this.oldHue)},isValidHex:function(e){return(0,i.default)(e).isValid()},simpleCheckForValidColor:function(e){for(var t=["r","g","b","a","h","s","l","v"],n=0,r=0,a=0;a<t.length;a++){var i=t[a];e[i]&&(n++,isNaN(e[i])||r++)}if(n===r)return e}}}},function(e,t,n){"use strict";function r(e){c||n(28)}Object.defineProperty(t,"__esModule",{value:!0});var a=n(10),i=n.n(a);for(var o in a)"default"!==o&&function(e){n.d(t,e,function(){return a[e]})}(o);var s=n(30),c=!1,l=n(2),u=r,d=l(i.a,s.a,!1,u,null,null);d.options.__file="src/components/common/EditableInput.vue",t.default=d.exports},function(e,t,n){"use strict";function r(e){c||n(43)}Object.defineProperty(t,"__esModule",{value:!0});var a=n(14),i=n.n(a);for(var o in a)"default"!==o&&function(e){n.d(t,e,function(){return a[e]})}(o);var s=n(45),c=!1,l=n(2),u=r,d=l(i.a,s.a,!1,u,null,null);d.options.__file="src/components/common/Hue.vue",t.default=d.exports},function(e,t,n){"use strict";function r(e){c||n(55)}Object.defineProperty(t,"__esModule",{value:!0});var a=n(17),i=n.n(a);for(var o in a)"default"!==o&&function(e){n.d(t,e,function(){return a[e]})}(o);var s=n(59),c=!1,l=n(2),u=r,d=l(i.a,s.a,!1,u,null,null);d.options.__file="src/components/common/Saturation.vue",t.default=d.exports},function(e,t,n){"use strict";function r(e){c||n(60)}Object.defineProperty(t,"__esModule",{value:!0});var a=n(18),i=n.n(a);for(var o in a)"default"!==o&&function(e){n.d(t,e,function(){return a[e]})}(o);var s=n(65),c=!1,l=n(2),u=r,d=l(i.a,s.a,!1,u,null,null);d.options.__file="src/components/common/Alpha.vue",t.default=d.exports},function(e,t,n){"use strict";function r(e){c||n(62)}Object.defineProperty(t,"__esModule",{value:!0});var a=n(19),i=n.n(a);for(var o in a)"default"!==o&&function(e){n.d(t,e,function(){return a[e]})}(o);var s=n(64),c=!1,l=n(2),u=r,d=l(i.a,s.a,!1,u,null,null);d.options.__file="src/components/common/Checkboard.vue",t.default=d.exports},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var a=n(3),i=r(a),o=n(4),s=r(o),c=["#4D4D4D","#999999","#FFFFFF","#F44E3B","#FE9200","#FCDC00","#DBDF00","#A4DD00","#68CCCA","#73D8FF","#AEA1FF","#FDA1FF","#333333","#808080","#CCCCCC","#D33115","#E27300","#FCC400","#B0BC00","#68BC00","#16A5A5","#009CE0","#7B64FF","#FA28FF","#000000","#666666","#B3B3B3","#9F0500","#C45100","#FB9E00","#808900","#194D33","#0C797D","#0062B1","#653294","#AB149E"];t.default={name:"Compact",mixins:[i.default],props:{palette:{type:Array,default:function(){return c}}},components:{"ed-in":s.default},computed:{pick:function(){return this.colors.hex}},methods:{handlerClick:function(e){this.colorChange({hex:e,source:"hex"})}}}},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default={name:"editableInput",props:{label:String,desc:String,value:[String,Number],max:Number,min:Number,arrowOffset:{type:Number,default:1}},computed:{val:{get:function(){return this.value},set:function(e){if(!(void 0!==this.max&&+e>this.max))return e;this.$refs.input.value=this.max}}},methods:{update:function(e){this.handleChange(e.target.value)},handleChange:function(e){var t={};t[this.label]=e,void 0===t.hex&&void 0===t["#"]?this.$emit("change",t):e.length>5&&this.$emit("change",t)},handleBlur:function(e){console.log(e)},handleKeyDown:function(e){var t=this.val,n=Number(t);if(n){var r=this.arrowOffset||1;38===e.keyCode&&(t=n+r,this.handleChange(t),e.preventDefault()),40===e.keyCode&&(t=n-r,this.handleChange(t),e.preventDefault())}},handleDrag:function(e){console.log(e)},handleMouseDown:function(e){console.log(e)}}}},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var r=n(3),a=function(e){return e&&e.__esModule?e:{default:e}}(r),i=["#FFFFFF","#F2F2F2","#E6E6E6","#D9D9D9","#CCCCCC","#BFBFBF","#B3B3B3","#A6A6A6","#999999","#8C8C8C","#808080","#737373","#666666","#595959","#4D4D4D","#404040","#333333","#262626","#0D0D0D","#000000"];t.default={name:"Grayscale",mixins:[a.default],props:{palette:{type:Array,default:function(){return i}}},components:{},computed:{pick:function(){return this.colors.hex}},methods:{handlerClick:function(e){this.colorChange({hex:e,source:"hex"})}}}},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var a=n(4),i=r(a),o=n(3),s=r(o);t.default={name:"Material",mixins:[s.default],components:{"ed-in":i.default},methods:{onChange:function(e){e&&(e.hex?this.isValidHex(e.hex)&&this.colorChange({hex:e.hex,source:"hex"}):(e.r||e.g||e.b)&&this.colorChange({r:e.r||this.colors.rgba.r,g:e.g||this.colors.rgba.g,b:e.b||this.colors.rgba.b,a:e.a||this.colors.rgba.a,source:"rgba"}))}}}},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var a=n(3),i=r(a),o=n(5),s=r(o);t.default={name:"Slider",mixins:[i.default],props:{direction:String},components:{hue:s.default},computed:{activeOffset:function(){return Math.round(100*this.colors.hsl.s)/100==.5?Math.round(100*this.colors.hsl.l)/100:0}},data:function(){return{swatches:[".80",".65",".50",".35",".20"]}},methods:{hueChange:function(e){this.colorChange(e)},handleSwClick:function(e,t){this.colorChange({h:this.colors.hsl.h,s:.5,l:t,source:"hsl"})}}}},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default={name:"Hue",props:{value:Object,direction:{type:String,default:"horizontal"}},data:function(){return{oldHue:0,pullDirection:""}},computed:{colors:function(){var e=this.value.hsl.h;return 0!==e&&e-this.oldHue>0&&(this.pullDirection="right"),0!==e&&e-this.oldHue<0&&(this.pullDirection="left"),this.oldHue=e,this.value},directionClass:function(){return{"vc-hue--horizontal":"horizontal"===this.direction,"vc-hue--vertical":"vertical"===this.direction}},pointerTop:function(){return"vertical"===this.direction?0===this.colors.hsl.h&&"right"===this.pullDirection?0:-100*this.colors.hsl.h/360+100+"%":0},pointerLeft:function(){return"vertical"===this.direction?0:0===this.colors.hsl.h&&"right"===this.pullDirection?"100%":100*this.colors.hsl.h/360+"%"}},methods:{handleChange:function(e,t){!t&&e.preventDefault();var n,r,a=this.$refs.container,i=a.clientWidth,o=a.clientHeight,s=a.getBoundingClientRect().left+window.pageXOffset,c=a.getBoundingClientRect().top+window.pageYOffset,l=e.pageX||(e.touches?e.touches[0].pageX:0),u=e.pageY||(e.touches?e.touches[0].pageY:0),d=l-s,h=u-c;"vertical"===this.direction?(h<0?n=360:h>o?n=0:(r=-100*h/o+100,n=360*r/100),this.colors.hsl.h!==n&&this.$emit("change",{h:n,s:this.colors.hsl.s,l:this.colors.hsl.l,a:this.colors.hsl.a,source:"hsl"})):(d<0?n=0:d>i?n=360:(r=100*d/i,n=360*r/100),this.colors.hsl.h!==n&&this.$emit("change",{h:n,s:this.colors.hsl.s,l:this.colors.hsl.l,a:this.colors.hsl.a,source:"hsl"}))},handleMouseDown:function(e){this.handleChange(e,!0),window.addEventListener("mousemove",this.handleChange),window.addEventListener("mouseup",this.handleMouseUp)},handleMouseUp:function(e){this.unbindEventListeners()},unbindEventListeners:function(){window.removeEventListener("mousemove",this.handleChange),window.removeEventListener("mouseup",this.handleMouseUp)}}}},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var a=n(50),i=r(a),o=n(3),s=r(o),c=["red","pink","purple","deepPurple","indigo","blue","lightBlue","cyan","teal","green","lightGreen","lime","yellow","amber","orange","deepOrange","brown","blueGrey","black"],l=["900","700","500","300","100"],u=function(){var e=[];return c.forEach(function(t){var n=[];"black"===t.toLowerCase()||"white"===t.toLowerCase()?n=n.concat(["#000000","#FFFFFF"]):l.forEach(function(e){var r=i.default[t][e];n.push(r.toUpperCase())}),e.push(n)}),e}();t.default={name:"Swatches",mixins:[s.default],props:{palette:{type:Array,default:function(){return u}}},computed:{pick:function(){return this.colors.hex}},methods:{equal:function(e){return e.toLowerCase()===this.colors.hex.toLowerCase()},handlerClick:function(e){this.colorChange({hex:e,source:"hex"})}}}},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var a=n(3),i=r(a),o=n(4),s=r(o),c=n(6),l=r(c),u=n(5),d=r(u),h=n(7),f=r(h);t.default={name:"Photoshop",mixins:[i.default],props:{head:{type:String,default:"Color Picker"},disableFields:{type:Boolean,default:!1}},components:{saturation:l.default,hue:d.default,alpha:f.default,"ed-in":s.default},data:function(){return{currentColor:"#FFF"}},computed:{hsv:function(){var e=this.colors.hsv;return{h:e.h.toFixed(),s:(100*e.s).toFixed(),v:(100*e.v).toFixed()}},hex:function(){var e=this.colors.hex;return e&&e.replace("#","")}},created:function(){this.currentColor=this.colors.hex},methods:{childChange:function(e){this.colorChange(e)},inputChange:function(e){e&&(e["#"]?this.isValidHex(e["#"])&&this.colorChange({hex:e["#"],source:"hex"}):e.r||e.g||e.b||e.a?this.colorChange({r:e.r||this.colors.rgba.r,g:e.g||this.colors.rgba.g,b:e.b||this.colors.rgba.b,a:e.a||this.colors.rgba.a,source:"rgba"}):(e.h||e.s||e.v)&&this.colorChange({h:e.h||this.colors.hsv.h,s:e.s/100||this.colors.hsv.s,v:e.v/100||this.colors.hsv.v,source:"hsv"}))},clickCurrentColor:function(){this.colorChange({hex:this.currentColor,source:"hex"})},handleAccept:function(){this.$emit("ok")},handleCancel:function(){this.$emit("cancel")}}}},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var r=n(57),a=function(e){return e&&e.__esModule?e:{default:e}}(r);t.default={name:"Saturation",props:{value:Object},computed:{colors:function(){return this.value},bgColor:function(){return"hsl("+this.colors.hsv.h+", 100%, 50%)"},pointerTop:function(){return-100*this.colors.hsv.v+1+100+"%"},pointerLeft:function(){return 100*this.colors.hsv.s+"%"}},methods:{throttle:(0,a.default)(function(e,t){e(t)},20,{leading:!0,trailing:!1}),handleChange:function(e,t){!t&&e.preventDefault();var n=this.$refs.container,r=n.clientWidth,a=n.clientHeight,i=n.getBoundingClientRect().left+window.pageXOffset,o=n.getBoundingClientRect().top+window.pageYOffset,s=e.pageX||(e.touches?e.touches[0].pageX:0),c=e.pageY||(e.touches?e.touches[0].pageY:0),l=s-i,u=c-o;l<0?l=0:l>r?l=r:u<0?u=0:u>a&&(u=a);var d=l/r,h=-u/a+1;h=h>0?h:0,h=h>1?1:h,this.throttle(this.onChange,{h:this.colors.hsv.h,s:d,v:h,a:this.colors.hsv.a,source:"hsva"})},onChange:function(e){this.$emit("change",e)},handleMouseDown:function(e){window.addEventListener("mousemove",this.handleChange),window.addEventListener("mouseup",this.handleChange),window.addEventListener("mouseup",this.handleMouseUp)},handleMouseUp:function(e){this.unbindEventListeners()},unbindEventListeners:function(){window.removeEventListener("mousemove",this.handleChange),window.removeEventListener("mouseup",this.handleChange),window.removeEventListener("mouseup",this.handleMouseUp)}}}},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var r=n(8),a=function(e){return e&&e.__esModule?e:{default:e}}(r);t.default={name:"Alpha",props:{value:Object,onChange:Function},components:{checkboard:a.default},computed:{colors:function(){return this.value},gradientColor:function(){var e=this.colors.rgba,t=[e.r,e.g,e.b].join(",");return"linear-gradient(to right, rgba("+t+", 0) 0%, rgba("+t+", 1) 100%)"}},methods:{handleChange:function(e,t){!t&&e.preventDefault();var n,r=this.$refs.container,a=r.clientWidth,i=r.getBoundingClientRect().left+window.pageXOffset,o=e.pageX||(e.touches?e.touches[0].pageX:0),s=o-i;n=s<0?0:s>a?1:Math.round(100*s/a)/100,this.colors.a!==n&&this.$emit("change",{h:this.colors.hsl.h,s:this.colors.hsl.s,l:this.colors.hsl.l,a:n,source:"rgba"})},handleMouseDown:function(e){this.handleChange(e,!0),window.addEventListener("mousemove",this.handleChange),window.addEventListener("mouseup",this.handleMouseUp)},handleMouseUp:function(){this.unbindEventListeners()},unbindEventListeners:function(){window.removeEventListener("mousemove",this.handleChange),window.removeEventListener("mouseup",this.handleMouseUp)}}}},function(e,t,n){"use strict";function r(e,t,n){if("undefined"==typeof document)return null;var r=document.createElement("canvas");r.width=r.height=2*n;var a=r.getContext("2d");return a?(a.fillStyle=e,a.fillRect(0,0,r.width,r.height),a.fillStyle=t,a.fillRect(0,0,n,n),a.translate(n,n),a.fillRect(0,0,n,n),r.toDataURL()):null}function a(e,t,n){var a=e+","+t+","+n;if(i[a])return i[a];var o=r(e,t,n);return i[a]=o,o}Object.defineProperty(t,"__esModule",{value:!0});var i={};t.default={name:"Checkboard",props:{size:{type:[Number,String],default:8},white:{type:String,default:"#fff"},grey:{type:String,default:"#e6e6e6"}},computed:{bgStyle:function(){return{"background-image":"url("+a(this.white,this.grey,this.size)+")"}}}}},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var a=n(3),i=r(a),o=n(4),s=r(o),c=n(6),l=r(c),u=n(5),d=r(u),h=n(7),f=r(h),p=n(8),v=r(p),g=["#D0021B","#F5A623","#F8E71C","#8B572A","#7ED321","#417505","#BD10E0","#9013FE","#4A90E2","#50E3C2","#B8E986","#000000","#4A4A4A","#9B9B9B","#FFFFFF"];t.default={name:"Sketch",mixins:[i.default],components:{saturation:l.default,hue:d.default,alpha:f.default,"ed-in":s.default,checkboard:v.default},props:{presetColors:{type:Array,default:function(){return g}},disableAlpha:{type:Boolean,default:!1},disableFields:{type:Boolean,default:!1}},computed:{hex:function(){return this.colors.hex.replace("#","")},activeColor:function(){var e=this.colors.rgba;return"rgba("+[e.r,e.g,e.b,e.a].join(",")+")"}},methods:{handlePreset:function(e){this.colorChange({hex:e,source:"hex"})},childChange:function(e){this.colorChange(e)},inputChange:function(e){e&&(e.hex?this.isValidHex(e.hex)&&this.colorChange({hex:e.hex,source:"hex"}):(e.r||e.g||e.b||e.a)&&this.colorChange({r:e.r||this.colors.rgba.r,g:e.g||this.colors.rgba.g,b:e.b||this.colors.rgba.b,a:e.a||this.colors.rgba.a,source:"rgba"}))}}}},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var a=n(3),i=r(a),o=n(4),s=r(o),c=n(6),l=r(c),u=n(5),d=r(u),h=n(7),f=r(h),p=n(8),v=r(p);t.default={name:"Chrome",mixins:[i.default],props:{disableAlpha:{type:Boolean,default:!1},disableFields:{type:Boolean,default:!1}},components:{saturation:l.default,hue:d.default,alpha:f.default,"ed-in":s.default,checkboard:v.default},data:function(){return{fields:["hex","rgba","hsla"],fieldsIndex:0,highlight:!1}},computed:{hsl:function(){var e=this.colors.hsl,t=e.h,n=e.s,r=e.l;return{h:t.toFixed(),s:(100*n).toFixed()+"%",l:(100*r).toFixed()+"%"}},activeColor:function(){var e=this.colors.rgba;return"rgba("+[e.r,e.g,e.b,e.a].join(",")+")"}},watch:{colors:function(e){e.a<1&&0===this.fieldsIndex&&(this.fieldsIndex=1)}},methods:{handlePreset:function(e){this.colorChange({hex:e,source:"hex"})},childChange:function(e){this.colorChange(e)},inputChange:function(e){if(e)if(e.hex)this.isValidHex(e.hex)&&this.colorChange({hex:e.hex,source:"hex"});else if(e.r||e.g||e.b||e.a)this.colorChange({r:e.r||this.colors.rgba.r,g:e.g||this.colors.rgba.g,b:e.b||this.colors.rgba.b,a:e.a||this.colors.rgba.a,source:"rgba"});else if(e.h||e.s||e.l){var t=e.s?e.s.replace("%","")/100:this.colors.hsl.s,n=e.l?e.l.replace("%","")/100:this.colors.hsl.l;this.colorChange({h:e.h||this.colors.hsl.h,s:t,l:n,source:"hsl"})}},toggleViews:function(){if(this.fieldsIndex>=2)return void(this.fieldsIndex=this.colors.a<1?1:0);this.fieldsIndex++},showHighlight:function(){this.highlight=!0},hideHighlight:function(){this.highlight=!1}}}},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}var a=n(23),i=r(a),o=n(32),s=r(o),c=n(36),l=r(c),u=n(40),d=r(u),h=n(47),f=r(h),p=n(52),v=r(p),g=n(67),b=r(g),x=n(71),m=r(x),_=n(7),w=r(_),C=n(8),y=r(C),k=n(4),F=r(k),A=n(5),S=r(A),M=n(6),E=r(M),j=n(3),D=r(j),O={version:"2.4.5",Compact:i.default,Grayscale:s.default,Material:l.default,Slider:d.default,Swatches:f.default,Photoshop:v.default,Sketch:b.default,Chrome:m.default,Alpha:w.default,Checkboard:y.default,EditableInput:F.default,Hue:S.default,Saturation:E.default,ColorMixin:D.default};e.exports=O},function(e,t,n){"use strict";function r(e){c||n(24)}Object.defineProperty(t,"__esModule",{value:!0});var a=n(9),i=n.n(a);for(var o in a)"default"!==o&&function(e){n.d(t,e,function(){return a[e]})}(o);var s=n(31),c=!1,l=n(2),u=r,d=l(i.a,s.a,!1,u,null,null);d.options.__file="src/components/Compact.vue",t.default=d.exports},function(e,t,n){var r=n(25);"string"==typeof r&&(r=[[e.i,r,""]]),r.locals&&(e.exports=r.locals);n(1)("cee7b64a",r,!1)},function(e,t,n){t=e.exports=n(0)(!1),t.push([e.i,"\n.vc-compact {\n  padding-top: 5px;\n  padding-left: 5px;\n  width: 240px;\n  border-radius: 2px;\n  box-shadow: 0 2px 10px rgba(0,0,0,.12), 0 2px 5px rgba(0,0,0,.16);\n  background-color: #fff;\n}\n.vc-compact-colors {\n  overflow: hidden;\n  padding: 0;\n  margin: 0;\n}\n.vc-compact-color-item {\n  list-style: none;\n  width: 15px;\n  height: 15px;\n  float: left;\n  margin-right: 5px;\n  margin-bottom: 5px;\n  position: relative;\n  cursor: pointer;\n}\n.vc-compact-color-item--white {\n  box-shadow: inset 0 0 0 1px #ddd;\n}\n.vc-compact-color-item--white .vc-compact-dot {\n  background: #000;\n}\n.vc-compact-dot {\n  position: absolute;\n  top: 5px;\n  right: 5px;\n  bottom: 5px;\n  left: 5px;\n  border-radius: 50%;\n  opacity: 1;\n  background: #fff;\n}\n",""])},function(e,t){e.exports=function(e,t){for(var n=[],r={},a=0;a<t.length;a++){var i=t[a],o=i[0],s=i[1],c=i[2],l=i[3],u={id:e+":"+a,css:s,media:c,sourceMap:l};r[o]?r[o].parts.push(u):n.push(r[o]={id:o,parts:[u]})}return n}},function(e,t,n){var r;!function(a){function i(e,t){if(e=e||"",t=t||{},e instanceof i)return e;if(!(this instanceof i))return new i(e,t);var n=o(e);this._originalInput=e,this._r=n.r,this._g=n.g,this._b=n.b,this._a=n.a,this._roundA=q(100*this._a)/100,this._format=t.format||n.format,this._gradientType=t.gradientType,this._r<1&&(this._r=q(this._r)),this._g<1&&(this._g=q(this._g)),this._b<1&&(this._b=q(this._b)),this._ok=n.ok,this._tc_id=U++}function o(e){var t={r:0,g:0,b:0},n=1,r=null,a=null,i=null,o=!1,c=!1;return"string"==typeof e&&(e=$(e)),"object"==typeof e&&(z(e.r)&&z(e.g)&&z(e.b)?(t=s(e.r,e.g,e.b),o=!0,c="%"===String(e.r).substr(-1)?"prgb":"rgb"):z(e.h)&&z(e.s)&&z(e.v)?(r=L(e.s),a=L(e.v),t=d(e.h,r,a),o=!0,c="hsv"):z(e.h)&&z(e.s)&&z(e.l)&&(r=L(e.s),i=L(e.l),t=l(e.h,r,i),o=!0,c="hsl"),e.hasOwnProperty("a")&&(n=e.a)),n=M(n),{ok:o,format:e.format||c,r:V(255,X(t.r,0)),g:V(255,X(t.g,0)),b:V(255,X(t.b,0)),a:n}}function s(e,t,n){return{r:255*E(e,255),g:255*E(t,255),b:255*E(n,255)}}function c(e,t,n){e=E(e,255),t=E(t,255),n=E(n,255);var r,a,i=X(e,t,n),o=V(e,t,n),s=(i+o)/2;if(i==o)r=a=0;else{var c=i-o;switch(a=s>.5?c/(2-i-o):c/(i+o),i){case e:r=(t-n)/c+(t<n?6:0);break;case t:r=(n-e)/c+2;break;case n:r=(e-t)/c+4}r/=6}return{h:r,s:a,l:s}}function l(e,t,n){function r(e,t,n){return n<0&&(n+=1),n>1&&(n-=1),n<1/6?e+6*(t-e)*n:n<.5?t:n<2/3?e+(t-e)*(2/3-n)*6:e}var a,i,o;if(e=E(e,360),t=E(t,100),n=E(n,100),0===t)a=i=o=n;else{var s=n<.5?n*(1+t):n+t-n*t,c=2*n-s;a=r(c,s,e+1/3),i=r(c,s,e),o=r(c,s,e-1/3)}return{r:255*a,g:255*i,b:255*o}}function u(e,t,n){e=E(e,255),t=E(t,255),n=E(n,255);var r,a,i=X(e,t,n),o=V(e,t,n),s=i,c=i-o;if(a=0===i?0:c/i,i==o)r=0;else{switch(i){case e:r=(t-n)/c+(t<n?6:0);break;case t:r=(n-e)/c+2;break;case n:r=(e-t)/c+4}r/=6}return{h:r,s:a,v:s}}function d(e,t,n){e=6*E(e,360),t=E(t,100),n=E(n,100);var r=a.floor(e),i=e-r,o=n*(1-t),s=n*(1-i*t),c=n*(1-(1-i)*t),l=r%6;return{r:255*[n,s,o,o,c,n][l],g:255*[c,n,n,s,o,o][l],b:255*[o,o,c,n,n,s][l]}}function h(e,t,n,r){var a=[B(q(e).toString(16)),B(q(t).toString(16)),B(q(n).toString(16))];return r&&a[0].charAt(0)==a[0].charAt(1)&&a[1].charAt(0)==a[1].charAt(1)&&a[2].charAt(0)==a[2].charAt(1)?a[0].charAt(0)+a[1].charAt(0)+a[2].charAt(0):a.join("")}function f(e,t,n,r,a){var i=[B(q(e).toString(16)),B(q(t).toString(16)),B(q(n).toString(16)),B(H(r))];return a&&i[0].charAt(0)==i[0].charAt(1)&&i[1].charAt(0)==i[1].charAt(1)&&i[2].charAt(0)==i[2].charAt(1)&&i[3].charAt(0)==i[3].charAt(1)?i[0].charAt(0)+i[1].charAt(0)+i[2].charAt(0)+i[3].charAt(0):i.join("")}function p(e,t,n,r){return[B(H(r)),B(q(e).toString(16)),B(q(t).toString(16)),B(q(n).toString(16))].join("")}function v(e,t){t=0===t?0:t||10;var n=i(e).toHsl();return n.s-=t/100,n.s=j(n.s),i(n)}function g(e,t){t=0===t?0:t||10;var n=i(e).toHsl();return n.s+=t/100,n.s=j(n.s),i(n)}function b(e){return i(e).desaturate(100)}function x(e,t){t=0===t?0:t||10;var n=i(e).toHsl();return n.l+=t/100,n.l=j(n.l),i(n)}function m(e,t){t=0===t?0:t||10;var n=i(e).toRgb();return n.r=X(0,V(255,n.r-q(-t/100*255))),n.g=X(0,V(255,n.g-q(-t/100*255))),n.b=X(0,V(255,n.b-q(-t/100*255))),i(n)}function _(e,t){t=0===t?0:t||10;var n=i(e).toHsl();return n.l-=t/100,n.l=j(n.l),i(n)}function w(e,t){var n=i(e).toHsl(),r=(n.h+t)%360;return n.h=r<0?360+r:r,i(n)}function C(e){var t=i(e).toHsl();return t.h=(t.h+180)%360,i(t)}function y(e){var t=i(e).toHsl(),n=t.h;return[i(e),i({h:(n+120)%360,s:t.s,l:t.l}),i({h:(n+240)%360,s:t.s,l:t.l})]}function k(e){var t=i(e).toHsl(),n=t.h;return[i(e),i({h:(n+90)%360,s:t.s,l:t.l}),i({h:(n+180)%360,s:t.s,l:t.l}),i({h:(n+270)%360,s:t.s,l:t.l})]}function F(e){var t=i(e).toHsl(),n=t.h;return[i(e),i({h:(n+72)%360,s:t.s,l:t.l}),i({h:(n+216)%360,s:t.s,l:t.l})]}function A(e,t,n){t=t||6,n=n||30;var r=i(e).toHsl(),a=360/n,o=[i(e)];for(r.h=(r.h-(a*t>>1)+720)%360;--t;)r.h=(r.h+a)%360,o.push(i(r));return o}function S(e,t){t=t||6;for(var n=i(e).toHsv(),r=n.h,a=n.s,o=n.v,s=[],c=1/t;t--;)s.push(i({h:r,s:a,v:o})),o=(o+c)%1;return s}function M(e){return e=parseFloat(e),(isNaN(e)||e<0||e>1)&&(e=1),e}function E(e,t){O(e)&&(e="100%");var n=R(e);return e=V(t,X(0,parseFloat(e))),n&&(e=parseInt(e*t,10)/100),a.abs(e-t)<1e-6?1:e%t/parseFloat(t)}function j(e){return V(1,X(0,e))}function D(e){return parseInt(e,16)}function O(e){return"string"==typeof e&&-1!=e.indexOf(".")&&1===parseFloat(e)}function R(e){return"string"==typeof e&&-1!=e.indexOf("%")}function B(e){return 1==e.length?"0"+e:""+e}function L(e){return e<=1&&(e=100*e+"%"),e}function H(e){return a.round(255*parseFloat(e)).toString(16)}function P(e){return D(e)/255}function z(e){return!!K.CSS_UNIT.exec(e)}function $(e){e=e.replace(I,"").replace(T,"").toLowerCase();var t=!1;if(W[e])e=W[e],t=!0;else if("transparent"==e)return{r:0,g:0,b:0,a:0,format:"name"};var n;return(n=K.rgb.exec(e))?{r:n[1],g:n[2],b:n[3]}:(n=K.rgba.exec(e))?{r:n[1],g:n[2],b:n[3],a:n[4]}:(n=K.hsl.exec(e))?{h:n[1],s:n[2],l:n[3]}:(n=K.hsla.exec(e))?{h:n[1],s:n[2],l:n[3],a:n[4]}:(n=K.hsv.exec(e))?{h:n[1],s:n[2],v:n[3]}:(n=K.hsva.exec(e))?{h:n[1],s:n[2],v:n[3],a:n[4]}:(n=K.hex8.exec(e))?{r:D(n[1]),g:D(n[2]),b:D(n[3]),a:P(n[4]),format:t?"name":"hex8"}:(n=K.hex6.exec(e))?{r:D(n[1]),g:D(n[2]),b:D(n[3]),format:t?"name":"hex"}:(n=K.hex4.exec(e))?{r:D(n[1]+""+n[1]),g:D(n[2]+""+n[2]),b:D(n[3]+""+n[3]),a:P(n[4]+""+n[4]),format:t?"name":"hex8"}:!!(n=K.hex3.exec(e))&&{r:D(n[1]+""+n[1]),g:D(n[2]+""+n[2]),b:D(n[3]+""+n[3]),format:t?"name":"hex"}}function N(e){var t,n;return e=e||{level:"AA",size:"small"},t=(e.level||"AA").toUpperCase(),n=(e.size||"small").toLowerCase(),"AA"!==t&&"AAA"!==t&&(t="AA"),"small"!==n&&"large"!==n&&(n="small"),{level:t,size:n}}var I=/^\s+/,T=/\s+$/,U=0,q=a.round,V=a.min,X=a.max,G=a.random;i.prototype={isDark:function(){return this.getBrightness()<128},isLight:function(){return!this.isDark()},isValid:function(){return this._ok},getOriginalInput:function(){return this._originalInput},getFormat:function(){return this._format},getAlpha:function(){return this._a},getBrightness:function(){var e=this.toRgb();return(299*e.r+587*e.g+114*e.b)/1e3},getLuminance:function(){var e,t,n,r,i,o,s=this.toRgb();return e=s.r/255,t=s.g/255,n=s.b/255,r=e<=.03928?e/12.92:a.pow((e+.055)/1.055,2.4),i=t<=.03928?t/12.92:a.pow((t+.055)/1.055,2.4),o=n<=.03928?n/12.92:a.pow((n+.055)/1.055,2.4),.2126*r+.7152*i+.0722*o},setAlpha:function(e){return this._a=M(e),this._roundA=q(100*this._a)/100,this},toHsv:function(){var e=u(this._r,this._g,this._b);return{h:360*e.h,s:e.s,v:e.v,a:this._a}},toHsvString:function(){var e=u(this._r,this._g,this._b),t=q(360*e.h),n=q(100*e.s),r=q(100*e.v);return 1==this._a?"hsv("+t+", "+n+"%, "+r+"%)":"hsva("+t+", "+n+"%, "+r+"%, "+this._roundA+")"},toHsl:function(){var e=c(this._r,this._g,this._b);return{h:360*e.h,s:e.s,l:e.l,a:this._a}},toHslString:function(){var e=c(this._r,this._g,this._b),t=q(360*e.h),n=q(100*e.s),r=q(100*e.l);return 1==this._a?"hsl("+t+", "+n+"%, "+r+"%)":"hsla("+t+", "+n+"%, "+r+"%, "+this._roundA+")"},toHex:function(e){return h(this._r,this._g,this._b,e)},toHexString:function(e){return"#"+this.toHex(e)},toHex8:function(e){return f(this._r,this._g,this._b,this._a,e)},toHex8String:function(e){return"#"+this.toHex8(e)},toRgb:function(){return{r:q(this._r),g:q(this._g),b:q(this._b),a:this._a}},toRgbString:function(){return 1==this._a?"rgb("+q(this._r)+", "+q(this._g)+", "+q(this._b)+")":"rgba("+q(this._r)+", "+q(this._g)+", "+q(this._b)+", "+this._roundA+")"},toPercentageRgb:function(){return{r:q(100*E(this._r,255))+"%",g:q(100*E(this._g,255))+"%",b:q(100*E(this._b,255))+"%",a:this._a}},toPercentageRgbString:function(){return 1==this._a?"rgb("+q(100*E(this._r,255))+"%, "+q(100*E(this._g,255))+"%, "+q(100*E(this._b,255))+"%)":"rgba("+q(100*E(this._r,255))+"%, "+q(100*E(this._g,255))+"%, "+q(100*E(this._b,255))+"%, "+this._roundA+")"},toName:function(){return 0===this._a?"transparent":!(this._a<1)&&(Y[h(this._r,this._g,this._b,!0)]||!1)},toFilter:function(e){var t="#"+p(this._r,this._g,this._b,this._a),n=t,r=this._gradientType?"GradientType = 1, ":"";if(e){var a=i(e);n="#"+p(a._r,a._g,a._b,a._a)}return"progid:DXImageTransform.Microsoft.gradient("+r+"startColorstr="+t+",endColorstr="+n+")"},toString:function(e){var t=!!e;e=e||this._format;var n=!1,r=this._a<1&&this._a>=0;return t||!r||"hex"!==e&&"hex6"!==e&&"hex3"!==e&&"hex4"!==e&&"hex8"!==e&&"name"!==e?("rgb"===e&&(n=this.toRgbString()),"prgb"===e&&(n=this.toPercentageRgbString()),"hex"!==e&&"hex6"!==e||(n=this.toHexString()),"hex3"===e&&(n=this.toHexString(!0)),"hex4"===e&&(n=this.toHex8String(!0)),"hex8"===e&&(n=this.toHex8String()),"name"===e&&(n=this.toName()),"hsl"===e&&(n=this.toHslString()),"hsv"===e&&(n=this.toHsvString()),n||this.toHexString()):"name"===e&&0===this._a?this.toName():this.toRgbString()},clone:function(){return i(this.toString())},_applyModification:function(e,t){var n=e.apply(null,[this].concat([].slice.call(t)));return this._r=n._r,this._g=n._g,this._b=n._b,this.setAlpha(n._a),this},lighten:function(){return this._applyModification(x,arguments)},brighten:function(){return this._applyModification(m,arguments)},darken:function(){return this._applyModification(_,arguments)},desaturate:function(){return this._applyModification(v,arguments)},saturate:function(){return this._applyModification(g,arguments)},greyscale:function(){return this._applyModification(b,arguments)},spin:function(){return this._applyModification(w,arguments)},_applyCombination:function(e,t){return e.apply(null,[this].concat([].slice.call(t)))},analogous:function(){return this._applyCombination(A,arguments)},complement:function(){return this._applyCombination(C,arguments)},monochromatic:function(){return this._applyCombination(S,arguments)},splitcomplement:function(){return this._applyCombination(F,arguments)},triad:function(){return this._applyCombination(y,arguments)},tetrad:function(){return this._applyCombination(k,arguments)}},i.fromRatio=function(e,t){if("object"==typeof e){var n={};for(var r in e)e.hasOwnProperty(r)&&(n[r]="a"===r?e[r]:L(e[r]));e=n}return i(e,t)},i.equals=function(e,t){return!(!e||!t)&&i(e).toRgbString()==i(t).toRgbString()},i.random=function(){return i.fromRatio({r:G(),g:G(),b:G()})},i.mix=function(e,t,n){n=0===n?0:n||50;var r=i(e).toRgb(),a=i(t).toRgb(),o=n/100;return i({r:(a.r-r.r)*o+r.r,g:(a.g-r.g)*o+r.g,b:(a.b-r.b)*o+r.b,a:(a.a-r.a)*o+r.a})},i.readability=function(e,t){var n=i(e),r=i(t);return(a.max(n.getLuminance(),r.getLuminance())+.05)/(a.min(n.getLuminance(),r.getLuminance())+.05)},i.isReadable=function(e,t,n){var r,a,o=i.readability(e,t);switch(a=!1,r=N(n),r.level+r.size){case"AAsmall":case"AAAlarge":a=o>=4.5;break;case"AAlarge":a=o>=3;break;case"AAAsmall":a=o>=7}return a},i.mostReadable=function(e,t,n){var r,a,o,s,c=null,l=0;n=n||{},a=n.includeFallbackColors,o=n.level,s=n.size;for(var u=0;u<t.length;u++)(r=i.readability(e,t[u]))>l&&(l=r,c=i(t[u]));return i.isReadable(e,c,{level:o,size:s})||!a?c:(n.includeFallbackColors=!1,i.mostReadable(e,["#fff","#000"],n))};var W=i.names={aliceblue:"f0f8ff",antiquewhite:"faebd7",aqua:"0ff",aquamarine:"7fffd4",azure:"f0ffff",beige:"f5f5dc",bisque:"ffe4c4",black:"000",blanchedalmond:"ffebcd",blue:"00f",blueviolet:"8a2be2",brown:"a52a2a",burlywood:"deb887",burntsienna:"ea7e5d",cadetblue:"5f9ea0",chartreuse:"7fff00",chocolate:"d2691e",coral:"ff7f50",cornflowerblue:"6495ed",cornsilk:"fff8dc",crimson:"dc143c",cyan:"0ff",darkblue:"00008b",darkcyan:"008b8b",darkgoldenrod:"b8860b",darkgray:"a9a9a9",darkgreen:"006400",darkgrey:"a9a9a9",darkkhaki:"bdb76b",darkmagenta:"8b008b",darkolivegreen:"556b2f",darkorange:"ff8c00",darkorchid:"9932cc",darkred:"8b0000",darksalmon:"e9967a",darkseagreen:"8fbc8f",darkslateblue:"483d8b",darkslategray:"2f4f4f",darkslategrey:"2f4f4f",darkturquoise:"00ced1",darkviolet:"9400d3",deeppink:"ff1493",deepskyblue:"00bfff",dimgray:"696969",dimgrey:"696969",dodgerblue:"1e90ff",firebrick:"b22222",floralwhite:"fffaf0",forestgreen:"228b22",fuchsia:"f0f",gainsboro:"dcdcdc",ghostwhite:"f8f8ff",gold:"ffd700",goldenrod:"daa520",gray:"808080",green:"008000",greenyellow:"adff2f",grey:"808080",honeydew:"f0fff0",hotpink:"ff69b4",indianred:"cd5c5c",indigo:"4b0082",ivory:"fffff0",khaki:"f0e68c",lavender:"e6e6fa",lavenderblush:"fff0f5",lawngreen:"7cfc00",lemonchiffon:"fffacd",lightblue:"add8e6",lightcoral:"f08080",lightcyan:"e0ffff",lightgoldenrodyellow:"fafad2",lightgray:"d3d3d3",lightgreen:"90ee90",lightgrey:"d3d3d3",lightpink:"ffb6c1",lightsalmon:"ffa07a",lightseagreen:"20b2aa",lightskyblue:"87cefa",lightslategray:"789",lightslategrey:"789",lightsteelblue:"b0c4de",lightyellow:"ffffe0",lime:"0f0",limegreen:"32cd32",linen:"faf0e6",magenta:"f0f",maroon:"800000",mediumaquamarine:"66cdaa",mediumblue:"0000cd",mediumorchid:"ba55d3",mediumpurple:"9370db",mediumseagreen:"3cb371",mediumslateblue:"7b68ee",mediumspringgreen:"00fa9a",mediumturquoise:"48d1cc",mediumvioletred:"c71585",midnightblue:"191970",mintcream:"f5fffa",mistyrose:"ffe4e1",moccasin:"ffe4b5",navajowhite:"ffdead",navy:"000080",oldlace:"fdf5e6",olive:"808000",olivedrab:"6b8e23",orange:"ffa500",orangered:"ff4500",orchid:"da70d6",palegoldenrod:"eee8aa",palegreen:"98fb98",paleturquoise:"afeeee",palevioletred:"db7093",papayawhip:"ffefd5",peachpuff:"ffdab9",peru:"cd853f",pink:"ffc0cb",plum:"dda0dd",powderblue:"b0e0e6",purple:"800080",rebeccapurple:"663399",red:"f00",rosybrown:"bc8f8f",royalblue:"4169e1",saddlebrown:"8b4513",salmon:"fa8072",sandybrown:"f4a460",seagreen:"2e8b57",seashell:"fff5ee",sienna:"a0522d",silver:"c0c0c0",skyblue:"87ceeb",slateblue:"6a5acd",slategray:"708090",slategrey:"708090",snow:"fffafa",springgreen:"00ff7f",steelblue:"4682b4",tan:"d2b48c",teal:"008080",thistle:"d8bfd8",tomato:"ff6347",turquoise:"40e0d0",violet:"ee82ee",wheat:"f5deb3",white:"fff",whitesmoke:"f5f5f5",yellow:"ff0",yellowgreen:"9acd32"},Y=i.hexNames=function(e){var t={};for(var n in e)e.hasOwnProperty(n)&&(t[e[n]]=n);return t}(W),K=function(){var e="(?:[-\\+]?\\d*\\.\\d+%?)|(?:[-\\+]?\\d+%?)",t="[\\s|\\(]+("+e+")[,|\\s]+("+e+")[,|\\s]+("+e+")\\s*\\)?",n="[\\s|\\(]+("+e+")[,|\\s]+("+e+")[,|\\s]+("+e+")[,|\\s]+("+e+")\\s*\\)?";return{CSS_UNIT:new RegExp(e),rgb:new RegExp("rgb"+t),rgba:new RegExp("rgba"+n),hsl:new RegExp("hsl"+t),hsla:new RegExp("hsla"+n),hsv:new RegExp("hsv"+t),hsva:new RegExp("hsva"+n),hex3:/^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,hex6:/^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,hex4:/^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,hex8:/^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/}}();void 0!==e&&e.exports?e.exports=i:void 0!==(r=function(){return i}.call(t,n,t,e))&&(e.exports=r)}(Math)},function(e,t,n){var r=n(29);"string"==typeof r&&(r=[[e.i,r,""]]),r.locals&&(e.exports=r.locals);n(1)("d0d513f4",r,!1)},function(e,t,n){t=e.exports=n(0)(!1),t.push([e.i,"\n.vc-editable-input {\n  position: relative;\n}\n.vc-input__input {\n  padding: 0;\n  border: 0;\n  outline: none;\n}\n.vc-input__label {\n  text-transform: capitalize;\n}\n",""])},function(e,t,n){"use strict";var r=function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("div",{staticClass:"vc-editable-input"},[n("input",{directives:[{name:"model",rawName:"v-model",value:e.val,expression:"val"}],ref:"input",staticClass:"vc-input__input",domProps:{value:e.val},on:{keydown:e.handleKeyDown,input:[function(t){t.target.composing||(e.val=t.target.value)},e.update]}}),e._v(" "),n("span",{staticClass:"vc-input__label"},[e._v(e._s(e.label))]),e._v(" "),n("span",{staticClass:"vc-input__desc"},[e._v(e._s(e.desc))])])},a=[];r._withStripped=!0;var i={render:r,staticRenderFns:a};t.a=i},function(e,t,n){"use strict";var r=function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("div",{staticClass:"vc-compact"},[n("ul",{staticClass:"vc-compact-colors"},e._l(e.palette,function(t){return n("li",{key:t,staticClass:"vc-compact-color-item",class:{"vc-compact-color-item--white":"#FFFFFF"===t},style:{background:t},on:{click:function(n){e.handlerClick(t)}}},[n("div",{directives:[{name:"show",rawName:"v-show",value:t===e.pick,expression:"c === pick"}],staticClass:"vc-compact-dot"})])}))])},a=[];r._withStripped=!0;var i={render:r,staticRenderFns:a};t.a=i},function(e,t,n){"use strict";function r(e){c||n(33)}Object.defineProperty(t,"__esModule",{value:!0});var a=n(11),i=n.n(a);for(var o in a)"default"!==o&&function(e){n.d(t,e,function(){return a[e]})}(o);var s=n(35),c=!1,l=n(2),u=r,d=l(i.a,s.a,!1,u,null,null);d.options.__file="src/components/Grayscale.vue",t.default=d.exports},function(e,t,n){var r=n(34);"string"==typeof r&&(r=[[e.i,r,""]]),r.locals&&(e.exports=r.locals);n(1)("52769f95",r,!1)},function(e,t,n){t=e.exports=n(0)(!1),t.push([e.i,"\n.vc-grayscale {\n  width: 125px;\n  border-radius: 2px;\n  box-shadow: 0 2px 15px rgba(0,0,0,.12), 0 2px 10px rgba(0,0,0,.16);\n  background-color: #fff;\n}\n.vc-grayscale-colors {\n  border-radius: 2px;\n  overflow: hidden;\n  padding: 0;\n  margin: 0;\n}\n.vc-grayscale-color-item {\n  list-style: none;\n  width: 25px;\n  height: 25px;\n  float: left;\n  position: relative;\n  cursor: pointer;\n}\n.vc-grayscale-color-item--white .vc-grayscale-dot {\n  background: #000;\n}\n.vc-grayscale-dot {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: 6px;\n  height: 6px;\n  margin: -3px 0 0 -2px;\n  border-radius: 50%;\n  opacity: 1;\n  background: #fff;\n}\n",""])},function(e,t,n){"use strict";var r=function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("div",{staticClass:"vc-grayscale"},[n("ul",{staticClass:"vc-grayscale-colors"},e._l(e.palette,function(t){return n("li",{key:t,staticClass:"vc-grayscale-color-item",class:{"vc-grayscale-color-item--white":"#FFFFFF"==t},style:{background:t},on:{click:function(n){e.handlerClick(t)}}},[n("div",{directives:[{name:"show",rawName:"v-show",value:t===e.pick,expression:"c === pick"}],staticClass:"vc-grayscale-dot"})])}))])},a=[];r._withStripped=!0;var i={render:r,staticRenderFns:a};t.a=i},function(e,t,n){"use strict";function r(e){c||n(37)}Object.defineProperty(t,"__esModule",{value:!0});var a=n(12),i=n.n(a);for(var o in a)"default"!==o&&function(e){n.d(t,e,function(){return a[e]})}(o);var s=n(39),c=!1,l=n(2),u=r,d=l(i.a,s.a,!1,u,null,null);d.options.__file="src/components/Material.vue",t.default=d.exports},function(e,t,n){var r=n(38);"string"==typeof r&&(r=[[e.i,r,""]]),r.locals&&(e.exports=r.locals);n(1)("2712b48c",r,!1)},function(e,t,n){t=e.exports=n(0)(!1),t.push([e.i,'\n.vc-material {\n  width: 98px;\n  height: 98px;\n  padding: 16px;\n  font-family: "Roboto";\n  position: relative;\n  border-radius: 2px;\n  box-shadow: 0 2px 10px rgba(0,0,0,.12), 0 2px 5px rgba(0,0,0,.16);\n  background-color: #fff;\n}\n.vc-material .vc-input__input {\n  width: 100%;\n  margin-top: 12px;\n  font-size: 15px;\n  color: #333;\n  height: 30px;\n}\n.vc-material .vc-input__label {\n  position: absolute;\n  top: 0;\n  left: 0;\n  font-size: 11px;\n  color: #999;\n  text-transform: capitalize;\n}\n.vc-material-hex {\n  border-bottom-width: 2px;\n  border-bottom-style: solid;\n}\n.vc-material-split {\n  display: flex;\n  margin-right: -10px;\n  padding-top: 11px;\n}\n.vc-material-third {\n  flex: 1;\n  padding-right: 10px;\n}\n',""])},function(e,t,n){"use strict";var r=function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("div",{staticClass:"vc-material"},[n("ed-in",{staticClass:"vc-material-hex",style:{borderColor:e.colors.hex},attrs:{label:"hex"},on:{change:e.onChange},model:{value:e.colors.hex,callback:function(t){e.$set(e.colors,"hex",t)},expression:"colors.hex"}}),e._v(" "),n("div",{staticClass:"vc-material-split"},[n("div",{staticClass:"vc-material-third"},[n("ed-in",{attrs:{label:"r"},on:{change:e.onChange},model:{value:e.colors.rgba.r,callback:function(t){e.$set(e.colors.rgba,"r",t)},expression:"colors.rgba.r"}})],1),e._v(" "),n("div",{staticClass:"vc-material-third"},[n("ed-in",{attrs:{label:"g"},on:{change:e.onChange},model:{value:e.colors.rgba.g,callback:function(t){e.$set(e.colors.rgba,"g",t)},expression:"colors.rgba.g"}})],1),e._v(" "),n("div",{staticClass:"vc-material-third"},[n("ed-in",{attrs:{label:"b"},on:{change:e.onChange},model:{value:e.colors.rgba.b,callback:function(t){e.$set(e.colors.rgba,"b",t)},expression:"colors.rgba.b"}})],1)])],1)},a=[];r._withStripped=!0;var i={render:r,staticRenderFns:a};t.a=i},function(e,t,n){"use strict";function r(e){c||n(41)}Object.defineProperty(t,"__esModule",{value:!0});var a=n(13),i=n.n(a);for(var o in a)"default"!==o&&function(e){n.d(t,e,function(){return a[e]})}(o);var s=n(46),c=!1,l=n(2),u=r,d=l(i.a,s.a,!1,u,null,null);d.options.__file="src/components/Slider.vue",t.default=d.exports},function(e,t,n){var r=n(42);"string"==typeof r&&(r=[[e.i,r,""]]),r.locals&&(e.exports=r.locals);n(1)("598b9964",r,!1)},function(e,t,n){t=e.exports=n(0)(!1),t.push([e.i,"\n.vc-slider {\n  position: relative;\n  width: 410px;\n}\n.vc-slider-hue-warp {\n  height: 12px;\n  position: relative;\n}\n.vc-slider-hue-warp .vc-hue-picker {\n  width: 14px;\n  height: 14px;\n  border-radius: 6px;\n  transform: translate(-7px, -2px);\n  background-color: rgb(248, 248, 248);\n  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.37);\n}\n.vc-slider-swatches {\n  display: flex;\n  margin-top: 20px;\n}\n.vc-slider-swatch {\n  margin-right: 1px;\n  flex: 1;\n  width: 20%;\n}\n.vc-slider-swatch:first-child {\n  margin-right: 1px;\n}\n.vc-slider-swatch:first-child .vc-slider-swatch-picker {\n  border-radius: 2px 0px 0px 2px;\n}\n.vc-slider-swatch:last-child {\n  margin-right: 0;\n}\n.vc-slider-swatch:last-child .vc-slider-swatch-picker {\n  border-radius: 0px 2px 2px 0px;\n}\n.vc-slider-swatch-picker {\n  cursor: pointer;\n  height: 12px;\n}\n.vc-slider-swatch-picker--active {\n  transform: scaleY(1.8);\n  border-radius: 3.6px/2px;\n}\n",""])},function(e,t,n){var r=n(44);"string"==typeof r&&(r=[[e.i,r,""]]),r.locals&&(e.exports=r.locals);n(1)("af546530",r,!1)},function(e,t,n){t=e.exports=n(0)(!1),t.push([e.i,"\n.vc-hue {\n  position: absolute;\n  top: 0px;\n  right: 0px;\n  bottom: 0px;\n  left: 0px;\n  border-radius: 2px;\n}\n.vc-hue--horizontal {\n  background: linear-gradient(to right, #f00 0%, #ff0 17%, #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n}\n.vc-hue--vertical {\n  background: linear-gradient(to top, #f00 0%, #ff0 17%, #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n}\n.vc-hue-container {\n  cursor: pointer;\n  margin: 0 2px;\n  position: relative;\n  height: 100%;\n}\n.vc-hue-pointer {\n  z-index: 2;\n  position: absolute;\n}\n.vc-hue-picker {\n  cursor: pointer;\n  margin-top: 1px;\n  width: 4px;\n  border-radius: 1px;\n  height: 8px;\n  box-shadow: 0 0 2px rgba(0, 0, 0, .6);\n  background: #fff;\n  transform: translateX(-2px) ;\n}\n",""])},function(e,t,n){"use strict";var r=function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("div",{class:["vc-hue",e.directionClass]},[n("div",{ref:"container",staticClass:"vc-hue-container",on:{mousedown:e.handleMouseDown,touchmove:e.handleChange,touchstart:e.handleChange}},[n("div",{staticClass:"vc-hue-pointer",style:{top:e.pointerTop,left:e.pointerLeft}},[n("div",{staticClass:"vc-hue-picker"})])])])},a=[];r._withStripped=!0;var i={render:r,staticRenderFns:a};t.a=i},function(e,t,n){"use strict";var r=function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("div",{staticClass:"vc-slider"},[n("div",{staticClass:"vc-slider-hue-warp"},[n("hue",{on:{change:e.hueChange},model:{value:e.colors,callback:function(t){e.colors=t},expression:"colors"}})],1),e._v(" "),n("div",{staticClass:"vc-slider-swatches"},e._l(e.swatches,function(t,r){return n("div",{staticClass:"vc-slider-swatch",attrs:{"data-index":r},on:{click:function(n){e.handleSwClick(r,t)}}},[n("div",{staticClass:"vc-slider-swatch-picker",class:{"vc-slider-swatch-picker--active":t==e.activeOffset},style:{background:"hsl("+e.colors.hsl.h+", 50%, "+100*t+"%)"}})])}))])},a=[];r._withStripped=!0;var i={render:r,staticRenderFns:a};t.a=i},function(e,t,n){"use strict";function r(e){c||n(48)}Object.defineProperty(t,"__esModule",{value:!0});var a=n(15),i=n.n(a);for(var o in a)"default"!==o&&function(e){n.d(t,e,function(){return a[e]})}(o);var s=n(51),c=!1,l=n(2),u=r,d=l(i.a,s.a,!1,u,null,null);d.options.__file="src/components/Swatches.vue",t.default=d.exports},function(e,t,n){var r=n(49);"string"==typeof r&&(r=[[e.i,r,""]]),r.locals&&(e.exports=r.locals);n(1)("445d3d64",r,!1)},function(e,t,n){t=e.exports=n(0)(!1),t.push([e.i,"\n.vc-swatches {\n  width: 320px;\n  height: 240px;\n  overflow-y: scroll;\n  background-color: #fff;\n  box-shadow: 0 2px 10px rgba(0,0,0,.12), 0 2px 5px rgba(0,0,0,.16);\n}\n.vc-swatches-box {\n  padding: 16px 0 6px 16px;\n  overflow: hidden;\n}\n.vc-swatches-color-group {\n  padding-bottom: 10px;\n  width: 40px;\n  float: left;\n  margin-right: 10px;\n}\n.vc-swatches-color-it {\n  box-sizing: border-box;\n  width: 40px;\n  height: 24px;\n  cursor: pointer;\n  background: #880e4f;\n  margin-bottom: 1px;\n  overflow: hidden;\n  -ms-border-radius: 2px 2px 0 0;\n  -moz-border-radius: 2px 2px 0 0;\n  -o-border-radius: 2px 2px 0 0;\n  -webkit-border-radius: 2px 2px 0 0;\n  border-radius: 2px 2px 0 0;\n}\n.vc-swatches-color--white {\n  border: 1px solid #DDD;\n}\n.vc-swatches-pick {\n  fill: rgb(255, 255, 255);\n  margin-left: 8px;\n  display: block;\n}\n.vc-swatches-color--white .vc-swatches-pick {\n  fill: rgb(51, 51, 51);\n}\n",""])},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),n.d(t,"red",function(){return r}),n.d(t,"pink",function(){return a}),n.d(t,"purple",function(){return i}),n.d(t,"deepPurple",function(){return o}),n.d(t,"indigo",function(){return s}),n.d(t,"blue",function(){return c}),n.d(t,"lightBlue",function(){return l}),n.d(t,"cyan",function(){return u}),n.d(t,"teal",function(){return d}),n.d(t,"green",function(){return h}),n.d(t,"lightGreen",function(){return f}),n.d(t,"lime",function(){return p}),n.d(t,"yellow",function(){return v}),n.d(t,"amber",function(){return g}),n.d(t,"orange",function(){return b}),n.d(t,"deepOrange",function(){return x}),n.d(t,"brown",function(){return m}),n.d(t,"grey",function(){return _}),n.d(t,"blueGrey",function(){return w}),n.d(t,"darkText",function(){return C}),n.d(t,"lightText",function(){return y}),n.d(t,"darkIcons",function(){return k}),n.d(t,"lightIcons",function(){return F}),n.d(t,"white",function(){return A}),n.d(t,"black",function(){return S});var r={50:"#ffebee",100:"#ffcdd2",200:"#ef9a9a",300:"#e57373",400:"#ef5350",500:"#f44336",600:"#e53935",700:"#d32f2f",800:"#c62828",900:"#b71c1c",a100:"#ff8a80",a200:"#ff5252",a400:"#ff1744",a700:"#d50000"},a={50:"#fce4ec",100:"#f8bbd0",200:"#f48fb1",300:"#f06292",400:"#ec407a",500:"#e91e63",600:"#d81b60",700:"#c2185b",800:"#ad1457",900:"#880e4f",a100:"#ff80ab",a200:"#ff4081",a400:"#f50057",a700:"#c51162"},i={50:"#f3e5f5",100:"#e1bee7",200:"#ce93d8",300:"#ba68c8",400:"#ab47bc",500:"#9c27b0",600:"#8e24aa",700:"#7b1fa2",800:"#6a1b9a",900:"#4a148c",a100:"#ea80fc",a200:"#e040fb",a400:"#d500f9",a700:"#aa00ff"},o={50:"#ede7f6",100:"#d1c4e9",200:"#b39ddb",300:"#9575cd",400:"#7e57c2",500:"#673ab7",600:"#5e35b1",700:"#512da8",800:"#4527a0",900:"#311b92",a100:"#b388ff",a200:"#7c4dff",a400:"#651fff",a700:"#6200ea"},s={50:"#e8eaf6",100:"#c5cae9",200:"#9fa8da",300:"#7986cb",400:"#5c6bc0",500:"#3f51b5",600:"#3949ab",700:"#303f9f",800:"#283593",900:"#1a237e",a100:"#8c9eff",a200:"#536dfe",a400:"#3d5afe",a700:"#304ffe"},c={50:"#e3f2fd",100:"#bbdefb",200:"#90caf9",300:"#64b5f6",400:"#42a5f5",500:"#2196f3",600:"#1e88e5",700:"#1976d2",800:"#1565c0",900:"#0d47a1",a100:"#82b1ff",a200:"#448aff",a400:"#2979ff",a700:"#2962ff"},l={50:"#e1f5fe",100:"#b3e5fc",200:"#81d4fa",300:"#4fc3f7",400:"#29b6f6",500:"#03a9f4",600:"#039be5",700:"#0288d1",800:"#0277bd",900:"#01579b",a100:"#80d8ff",a200:"#40c4ff",a400:"#00b0ff",a700:"#0091ea"},u={50:"#e0f7fa",100:"#b2ebf2",200:"#80deea",300:"#4dd0e1",400:"#26c6da",500:"#00bcd4",600:"#00acc1",700:"#0097a7",800:"#00838f",900:"#006064",a100:"#84ffff",a200:"#18ffff",a400:"#00e5ff",a700:"#00b8d4"},d={50:"#e0f2f1",100:"#b2dfdb",200:"#80cbc4",300:"#4db6ac",400:"#26a69a",500:"#009688",600:"#00897b",700:"#00796b",800:"#00695c",900:"#004d40",a100:"#a7ffeb",a200:"#64ffda",a400:"#1de9b6",a700:"#00bfa5"},h={50:"#e8f5e9",100:"#c8e6c9",200:"#a5d6a7",300:"#81c784",400:"#66bb6a",500:"#4caf50",600:"#43a047",700:"#388e3c",800:"#2e7d32",900:"#1b5e20",a100:"#b9f6ca",a200:"#69f0ae",a400:"#00e676",a700:"#00c853"},f={50:"#f1f8e9",100:"#dcedc8",200:"#c5e1a5",300:"#aed581",400:"#9ccc65",500:"#8bc34a",600:"#7cb342",700:"#689f38",800:"#558b2f",900:"#33691e",a100:"#ccff90",a200:"#b2ff59",a400:"#76ff03",a700:"#64dd17"},p={50:"#f9fbe7",100:"#f0f4c3",200:"#e6ee9c",300:"#dce775",400:"#d4e157",500:"#cddc39",600:"#c0ca33",700:"#afb42b",800:"#9e9d24",900:"#827717",a100:"#f4ff81",a200:"#eeff41",a400:"#c6ff00",a700:"#aeea00"},v={50:"#fffde7",100:"#fff9c4",200:"#fff59d",300:"#fff176",400:"#ffee58",500:"#ffeb3b",600:"#fdd835",700:"#fbc02d",800:"#f9a825",900:"#f57f17",a100:"#ffff8d",a200:"#ffff00",a400:"#ffea00",a700:"#ffd600"},g={50:"#fff8e1",100:"#ffecb3",200:"#ffe082",300:"#ffd54f",400:"#ffca28",500:"#ffc107",600:"#ffb300",700:"#ffa000",800:"#ff8f00",900:"#ff6f00",a100:"#ffe57f",a200:"#ffd740",a400:"#ffc400",a700:"#ffab00"},b={50:"#fff3e0",100:"#ffe0b2",200:"#ffcc80",300:"#ffb74d",400:"#ffa726",500:"#ff9800",600:"#fb8c00",700:"#f57c00",800:"#ef6c00",900:"#e65100",a100:"#ffd180",a200:"#ffab40",a400:"#ff9100",a700:"#ff6d00"},x={50:"#fbe9e7",100:"#ffccbc",200:"#ffab91",300:"#ff8a65",400:"#ff7043",500:"#ff5722",600:"#f4511e",700:"#e64a19",800:"#d84315",900:"#bf360c",a100:"#ff9e80",a200:"#ff6e40",a400:"#ff3d00",a700:"#dd2c00"},m={50:"#efebe9",100:"#d7ccc8",200:"#bcaaa4",300:"#a1887f",400:"#8d6e63",500:"#795548",600:"#6d4c41",700:"#5d4037",800:"#4e342e",900:"#3e2723"},_={50:"#fafafa",100:"#f5f5f5",200:"#eeeeee",300:"#e0e0e0",400:"#bdbdbd",500:"#9e9e9e",600:"#757575",700:"#616161",800:"#424242",900:"#212121"},w={50:"#eceff1",100:"#cfd8dc",200:"#b0bec5",300:"#90a4ae",400:"#78909c",500:"#607d8b",600:"#546e7a",700:"#455a64",800:"#37474f",900:"#263238"},C={primary:"rgba(0, 0, 0, 0.87)",secondary:"rgba(0, 0, 0, 0.54)",disabled:"rgba(0, 0, 0, 0.38)",dividers:"rgba(0, 0, 0, 0.12)"},y={primary:"rgba(255, 255, 255, 1)",secondary:"rgba(255, 255, 255, 0.7)",disabled:"rgba(255, 255, 255, 0.5)",dividers:"rgba(255, 255, 255, 0.12)"},k={active:"rgba(0, 0, 0, 0.54)",inactive:"rgba(0, 0, 0, 0.38)"},F={active:"rgba(255, 255, 255, 1)",inactive:"rgba(255, 255, 255, 0.5)"},A="#ffffff",S="#000000";t.default={red:r,pink:a,purple:i,deepPurple:o,indigo:s,blue:c,lightBlue:l,cyan:u,teal:d,green:h,lightGreen:f,lime:p,yellow:v,amber:g,orange:b,deepOrange:x,brown:m,grey:_,blueGrey:w,darkText:C,lightText:y,darkIcons:k,lightIcons:F,white:A,black:S}},function(e,t,n){"use strict";var r=function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("div",{staticClass:"vc-swatches",attrs:{"data-pick":e.pick}},[n("div",{staticClass:"vc-swatches-box"},e._l(e.palette,function(t,r){return n("div",{key:r,staticClass:"vc-swatches-color-group"},e._l(t,function(t){return n("div",{key:t,class:["vc-swatches-color-it",{"vc-swatches-color--white":"#FFFFFF"===t}],style:{background:t},attrs:{"data-color":t},on:{click:function(n){e.handlerClick(t)}}},[n("div",{directives:[{name:"show",rawName:"v-show",value:e.equal(t),expression:"equal(c)"}],staticClass:"vc-swatches-pick"},[n("svg",{staticStyle:{width:"24px",height:"24px"},attrs:{viewBox:"0 0 24 24"}},[n("path",{attrs:{d:"M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"}})])])])}))}))])},a=[];r._withStripped=!0;var i={render:r,staticRenderFns:a};t.a=i},function(e,t,n){"use strict";function r(e){c||n(53)}Object.defineProperty(t,"__esModule",{value:!0});var a=n(16),i=n.n(a);for(var o in a)"default"!==o&&function(e){n.d(t,e,function(){return a[e]})}(o);var s=n(66),c=!1,l=n(2),u=r,d=l(i.a,s.a,!1,u,null,null);d.options.__file="src/components/Photoshop.vue",t.default=d.exports},function(e,t,n){var r=n(54);"string"==typeof r&&(r=[[e.i,r,""]]),r.locals&&(e.exports=r.locals);n(1)("bdf43978",r,!1)},function(e,t,n){t=e.exports=n(0)(!1),t.push([e.i,'\n.vc-photoshop {\n  background: #DCDCDC;\n  border-radius: 4px;\n  box-shadow: 0 0 0 1px rgba(0,0,0,.25), 0 8px 16px rgba(0,0,0,.15);\n  box-sizing: initial;\n  width: 513px;\n  font-family: Roboto;\n}\n.vc-photoshop__disable-fields {\n  width: 390px;\n}\n.vc-ps-head {\n  background-image: linear-gradient(-180deg, #F0F0F0 0%, #D4D4D4 100%);\n  border-bottom: 1px solid #B1B1B1;\n  box-shadow: inset 0 1px 0 0 rgba(255,255,255,.2), inset 0 -1px 0 0 rgba(0,0,0,.02);\n  height: 23px;\n  line-height: 24px;\n  border-radius: 4px 4px 0 0;\n  font-size: 13px;\n  color: #4D4D4D;\n  text-align: center;\n}\n.vc-ps-body {\n  padding: 15px;\n  display: flex;\n}\n.vc-ps-saturation-wrap {\n  width: 256px;\n  height: 256px;\n  position: relative;\n  border: 2px solid #B3B3B3;\n  border-bottom: 2px solid #F0F0F0;\n  overflow: hidden;\n}\n.vc-ps-saturation-wrap .vc-saturation-circle {\n  width: 12px;\n  height: 12px;\n}\n.vc-ps-hue-wrap {\n  position: relative;\n  height: 256px;\n  width: 19px;\n  margin-left: 10px;\n  border: 2px solid #B3B3B3;\n  border-bottom: 2px solid #F0F0F0;\n}\n.vc-ps-hue-pointer {\n  position: relative;\n}\n.vc-ps-hue-pointer--left,\n.vc-ps-hue-pointer--right {\n  position: absolute;\n  width: 0;\n  height: 0;\n  border-style: solid;\n  border-width: 5px 0 5px 8px;\n  border-color: transparent transparent transparent #555;\n}\n.vc-ps-hue-pointer--left:after,\n.vc-ps-hue-pointer--right:after {\n  content: "";\n  width: 0;\n  height: 0;\n  border-style: solid;\n  border-width: 4px 0 4px 6px;\n  border-color: transparent transparent transparent #fff;\n  position: absolute;\n  top: 1px;\n  left: 1px;\n  transform: translate(-8px, -5px);\n}\n.vc-ps-hue-pointer--left {\n  transform: translate(-13px, -4px);\n}\n.vc-ps-hue-pointer--right {\n  transform: translate(20px, -4px) rotate(180deg);\n}\n.vc-ps-controls {\n  width: 180px;\n  margin-left: 10px;\n  display: flex;\n}\n.vc-ps-controls__disable-fields {\n  width: auto;\n}\n.vc-ps-actions {\n  margin-left: 20px;\n  flex: 1;\n}\n.vc-ps-ac-btn {\n  cursor: pointer;\n  background-image: linear-gradient(-180deg, #FFFFFF 0%, #E6E6E6 100%);\n  border: 1px solid #878787;\n  border-radius: 2px;\n  height: 20px;\n  box-shadow: 0 1px 0 0 #EAEAEA;\n  font-size: 14px;\n  color: #000;\n  line-height: 20px;\n  text-align: center;\n  margin-bottom: 10px;\n}\n.vc-ps-previews {\n  width: 60px;\n}\n.vc-ps-previews__swatches {\n  border: 1px solid #B3B3B3;\n  border-bottom: 1px solid #F0F0F0;\n  margin-bottom: 2px;\n  margin-top: 1px;\n}\n.vc-ps-previews__pr-color {\n  height: 34px;\n  box-shadow: inset 1px 0 0 #000, inset -1px 0 0 #000, inset 0 1px 0 #000;\n}\n.vc-ps-previews__label {\n  font-size: 14px;\n  color: #000;\n  text-align: center;\n}\n.vc-ps-fields {\n  padding-top: 5px;\n  padding-bottom: 9px;\n  width: 80px;\n  position: relative;\n}\n.vc-ps-fields .vc-input__input {\n  margin-left: 40%;\n  width: 40%;\n  height: 18px;\n  border: 1px solid #888888;\n  box-shadow: inset 0 1px 1px rgba(0,0,0,.1), 0 1px 0 0 #ECECEC;\n  margin-bottom: 5px;\n  font-size: 13px;\n  padding-left: 3px;\n  margin-right: 10px;\n}\n.vc-ps-fields .vc-input__label, .vc-ps-fields .vc-input__desc {\n  top: 0;\n  text-transform: uppercase;\n  font-size: 13px;\n  height: 18px;\n  line-height: 22px;\n  position: absolute;\n}\n.vc-ps-fields .vc-input__label {\n  left: 0;\n  width: 34px;\n}\n.vc-ps-fields .vc-input__desc {\n  right: 0;\n  width: 0;\n}\n.vc-ps-fields__divider {\n  height: 5px;\n}\n.vc-ps-fields__hex .vc-input__input {\n  margin-left: 20%;\n  width: 80%;\n  height: 18px;\n  border: 1px solid #888888;\n  box-shadow: inset 0 1px 1px rgba(0,0,0,.1), 0 1px 0 0 #ECECEC;\n  margin-bottom: 6px;\n  font-size: 13px;\n  padding-left: 3px;\n}\n.vc-ps-fields__hex .vc-input__label {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 14px;\n  text-transform: uppercase;\n  font-size: 13px;\n  height: 18px;\n  line-height: 22px;\n}\n',""])},function(e,t,n){var r=n(56);"string"==typeof r&&(r=[[e.i,r,""]]),r.locals&&(e.exports=r.locals);n(1)("4b2ac592",r,!1)},function(e,t,n){t=e.exports=n(0)(!1),t.push([e.i,"\n.vc-saturation,\n.vc-saturation--white,\n.vc-saturation--black {\n  cursor: pointer;\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n}\n.vc-saturation--white {\n  background: linear-gradient(to right, #fff, rgba(255,255,255,0));\n}\n.vc-saturation--black {\n  background: linear-gradient(to top, #000, rgba(0,0,0,0));\n}\n.vc-saturation-pointer {\n  cursor: pointer;\n  position: absolute;\n}\n.vc-saturation-circle {\n  cursor: head;\n  width: 4px;\n  height: 4px;\n  box-shadow: 0 0 0 1.5px #fff, inset 0 0 1px 1px rgba(0,0,0,.3), 0 0 1px 2px rgba(0,0,0,.4);\n  border-radius: 50%;\n  transform: translate(-2px, -2px);\n}\n",""])},function(e,t,n){(function(t){function n(e,t,n){function r(t){var n=v,r=g;return v=g=void 0,k=t,x=e.apply(r,n)}function i(e){return k=e,m=setTimeout(u,t),F?r(e):x}function o(e){var n=e-_,r=e-k,a=t-n;return A?C(a,b-r):a}function l(e){var n=e-_,r=e-k;return void 0===_||n>=t||n<0||A&&r>=b}function u(){var e=y();if(l(e))return d(e);m=setTimeout(u,o(e))}function d(e){return m=void 0,S&&v?r(e):(v=g=void 0,x)}function h(){void 0!==m&&clearTimeout(m),k=0,v=_=g=m=void 0}function f(){return void 0===m?x:d(y())}function p(){var e=y(),n=l(e);if(v=arguments,g=this,_=e,n){if(void 0===m)return i(_);if(A)return m=setTimeout(u,t),r(_)}return void 0===m&&(m=setTimeout(u,t)),x}var v,g,b,x,m,_,k=0,F=!1,A=!1,S=!0;if("function"!=typeof e)throw new TypeError(c);return t=s(t)||0,a(n)&&(F=!!n.leading,A="maxWait"in n,b=A?w(s(n.maxWait)||0,t):b,S="trailing"in n?!!n.trailing:S),p.cancel=h,p.flush=f,p}function r(e,t,r){var i=!0,o=!0;if("function"!=typeof e)throw new TypeError(c);return a(r)&&(i="leading"in r?!!r.leading:i,o="trailing"in r?!!r.trailing:o),n(e,t,{leading:i,maxWait:t,trailing:o})}function a(e){var t=typeof e;return!!e&&("object"==t||"function"==t)}function i(e){return!!e&&"object"==typeof e}function o(e){return"symbol"==typeof e||i(e)&&_.call(e)==u}function s(e){if("number"==typeof e)return e;if(o(e))return l;if(a(e)){var t="function"==typeof e.valueOf?e.valueOf():e;e=a(t)?t+"":t}if("string"!=typeof e)return 0===e?e:+e;e=e.replace(d,"");var n=f.test(e);return n||p.test(e)?v(e.slice(2),n?2:8):h.test(e)?l:+e}var c="Expected a function",l=NaN,u="[object Symbol]",d=/^\s+|\s+$/g,h=/^[-+]0x[0-9a-f]+$/i,f=/^0b[01]+$/i,p=/^0o[0-7]+$/i,v=parseInt,g="object"==typeof t&&t&&t.Object===Object&&t,b="object"==typeof self&&self&&self.Object===Object&&self,x=g||b||Function("return this")(),m=Object.prototype,_=m.toString,w=Math.max,C=Math.min,y=function(){return x.Date.now()};e.exports=r}).call(t,n(58))},function(e,t){var n;n=function(){return this}();try{n=n||Function("return this")()||(0,eval)("this")}catch(e){"object"==typeof window&&(n=window)}e.exports=n},function(e,t,n){"use strict";var r=function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("div",{ref:"container",staticClass:"vc-saturation",style:{background:e.bgColor},on:{mousedown:e.handleMouseDown,touchmove:e.handleChange,touchstart:e.handleChange}},[n("div",{staticClass:"vc-saturation--white"}),e._v(" "),n("div",{staticClass:"vc-saturation--black"}),e._v(" "),n("div",{staticClass:"vc-saturation-pointer",style:{top:e.pointerTop,left:e.pointerLeft}},[n("div",{staticClass:"vc-saturation-circle"})])])},a=[];r._withStripped=!0;var i={render:r,staticRenderFns:a};t.a=i},function(e,t,n){var r=n(61);"string"==typeof r&&(r=[[e.i,r,""]]),r.locals&&(e.exports=r.locals);n(1)("04f8680c",r,!1)},function(e,t,n){t=e.exports=n(0)(!1),t.push([e.i,"\n.vc-alpha {\n  position: absolute;\n  top: 0px;\n  right: 0px;\n  bottom: 0px;\n  left: 0px;\n}\n.vc-alpha-checkboard-wrap {\n  position: absolute;\n  top: 0px;\n  right: 0px;\n  bottom: 0px;\n  left: 0px;\n  overflow: hidden;\n}\n.vc-alpha-gradient {\n  position: absolute;\n  top: 0px;\n  right: 0px;\n  bottom: 0px;\n  left: 0px;\n}\n.vc-alpha-container {\n  cursor: pointer;\n  position: relative;\n  z-index: 2;\n  height: 100%;\n  margin: 0 3px;\n}\n.vc-alpha-pointer {\n  z-index: 2;\n  position: absolute;\n}\n.vc-alpha-picker {\n  cursor: pointer;\n  width: 4px;\n  border-radius: 1px;\n  height: 8px;\n  box-shadow: 0 0 2px rgba(0, 0, 0, .6);\n  background: #fff;\n  margin-top: 1px;\n  transform: translateX(-2px);\n}\n",""])},function(e,t,n){var r=n(63);"string"==typeof r&&(r=[[e.i,r,""]]),r.locals&&(e.exports=r.locals);n(1)("004624a2",r,!1)},function(e,t,n){t=e.exports=n(0)(!1),t.push([e.i,"\n.vc-checkerboard {\n  position: absolute;\n  top: 0px;\n  right: 0px;\n  bottom: 0px;\n  left: 0px;\n  background-size: contain;\n}\n",""])},function(e,t,n){"use strict";var r=function(){var e=this,t=e.$createElement;return(e._self._c||t)("div",{staticClass:"vc-checkerboard",style:e.bgStyle})},a=[];r._withStripped=!0;var i={render:r,staticRenderFns:a};t.a=i},function(e,t,n){"use strict";var r=function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("div",{staticClass:"vc-alpha"},[n("div",{staticClass:"vc-alpha-checkboard-wrap"},[n("checkboard")],1),e._v(" "),n("div",{staticClass:"vc-alpha-gradient",style:{background:e.gradientColor}}),e._v(" "),n("div",{ref:"container",staticClass:"vc-alpha-container",on:{mousedown:e.handleMouseDown,touchmove:e.handleChange,touchstart:e.handleChange}},[n("div",{staticClass:"vc-alpha-pointer",style:{left:100*e.colors.a+"%"}},[n("div",{staticClass:"vc-alpha-picker"})])])])},a=[];r._withStripped=!0;var i={render:r,staticRenderFns:a};t.a=i},function(e,t,n){"use strict";var r=function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("div",{class:["vc-photoshop",e.disableFields?"vc-photoshop__disable-fields":""]},[n("div",{staticClass:"vc-ps-head"},[e._v(e._s(e.head))]),e._v(" "),n("div",{staticClass:"vc-ps-body"},[n("div",{staticClass:"vc-ps-saturation-wrap"},[n("saturation",{on:{change:e.childChange},model:{value:e.colors,callback:function(t){e.colors=t},expression:"colors"}})],1),e._v(" "),n("div",{staticClass:"vc-ps-hue-wrap"},[n("hue",{attrs:{direction:"vertical"},on:{change:e.childChange},model:{value:e.colors,callback:function(t){e.colors=t},expression:"colors"}},[n("div",{staticClass:"vc-ps-hue-pointer"},[n("i",{staticClass:"vc-ps-hue-pointer--left"}),n("i",{staticClass:"vc-ps-hue-pointer--right"})])])],1),e._v(" "),n("div",{class:["vc-ps-controls",e.disableFields?"vc-ps-controls__disable-fields":""]},[n("div",{staticClass:"vc-ps-previews"},[n("div",{staticClass:"vc-ps-previews__label"},[e._v("new")]),e._v(" "),n("div",{staticClass:"vc-ps-previews__swatches"},[n("div",{staticClass:"vc-ps-previews__pr-color",style:{background:e.colors.hex}}),e._v(" "),n("div",{staticClass:"vc-ps-previews__pr-color",style:{background:e.currentColor},on:{click:e.clickCurrentColor}})]),e._v(" "),n("div",{staticClass:"vc-ps-previews__label"},[e._v("current")])]),e._v(" "),e.disableFields?e._e():n("div",{staticClass:"vc-ps-actions"},[n("div",{staticClass:"vc-ps-ac-btn",on:{click:e.handleAccept}},[e._v("OK")]),e._v(" "),n("div",{staticClass:"vc-ps-ac-btn",on:{click:e.handleCancel}},[e._v("Cancel")]),e._v(" "),n("div",{staticClass:"vc-ps-fields"},[n("ed-in",{attrs:{label:"h",desc:"°",value:e.hsv.h},on:{change:e.inputChange}}),e._v(" "),n("ed-in",{attrs:{label:"s",desc:"%",value:e.hsv.s,max:100},on:{change:e.inputChange}}),e._v(" "),n("ed-in",{attrs:{label:"v",desc:"%",value:e.hsv.v,max:100},on:{change:e.inputChange}}),e._v(" "),n("div",{staticClass:"vc-ps-fields__divider"}),e._v(" "),n("ed-in",{attrs:{label:"r",value:e.colors.rgba.r},on:{change:e.inputChange}}),e._v(" "),n("ed-in",{attrs:{label:"g",value:e.colors.rgba.g},on:{change:e.inputChange}}),e._v(" "),n("ed-in",{attrs:{label:"b",value:e.colors.rgba.b},on:{change:e.inputChange}}),e._v(" "),n("div",{staticClass:"vc-ps-fields__divider"}),e._v(" "),n("ed-in",{staticClass:"vc-ps-fields__hex",attrs:{label:"#",value:e.hex},on:{change:e.inputChange}})],1)])])])])},a=[];r._withStripped=!0;var i={render:r,staticRenderFns:a};t.a=i},function(e,t,n){"use strict";function r(e){c||n(68)}Object.defineProperty(t,"__esModule",{value:!0});var a=n(20),i=n.n(a);for(var o in a)"default"!==o&&function(e){n.d(t,e,function(){return a[e]})}(o);var s=n(70),c=!1,l=n(2),u=r,d=l(i.a,s.a,!1,u,null,null);d.options.__file="src/components/Sketch.vue",t.default=d.exports},function(e,t,n){var r=n(69);"string"==typeof r&&(r=[[e.i,r,""]]),r.locals&&(e.exports=r.locals);n(1)("e7574c18",r,!1)},function(e,t,n){t=e.exports=n(0)(!1),t.push([e.i,"\n.vc-sketch {\n  position: relative;\n  width: 200px;\n  padding: 10px 10px 0;\n  box-sizing: initial;\n  background: #fff;\n  border-radius: 4px;\n  box-shadow: 0 0 0 1px rgba(0,0,0,.15), 0 8px 16px rgba(0,0,0,.15);\n}\n.vc-sketch-saturation-wrap {\n  width: 100%;\n  padding-bottom: 75%;\n  position: relative;\n  overflow: hidden;\n}\n.vc-sketch-controls {\n  display: flex;\n}\n.vc-sketch-sliders {\n  padding: 4px 0;\n  flex: 1;\n}\n.vc-sketch-sliders .vc-hue,\n.vc-sketch-sliders .vc-alpha-gradient {\n  border-radius: 2px;\n}\n.vc-sketch-hue-wrap {\n  position: relative;\n  height: 10px;\n}\n.vc-sketch-alpha-wrap {\n  position: relative;\n  height: 10px;\n  margin-top: 4px;\n  overflow: hidden;\n}\n.vc-sketch-color-wrap {\n  width: 24px;\n  height: 24px;\n  position: relative;\n  margin-top: 4px;\n  margin-left: 4px;\n  border-radius: 3px;\n}\n.vc-sketch-active-color {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  border-radius: 2px;\n  box-shadow: inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25);\n  z-index: 2;\n}\n.vc-sketch-color-wrap .vc-checkerboard {\n  background-size: auto;\n}\n.vc-sketch-field {\n  display: flex;\n  padding-top: 4px;\n}\n.vc-sketch-field .vc-input__input {\n  width: 80%;\n  padding: 4px 10% 3px;\n  border: none;\n  box-shadow: inset 0 0 0 1px #ccc;\n  font-size: 11px;\n}\n.vc-sketch-field .vc-input__label {\n  display: block;\n  text-align: center;\n  font-size: 11px;\n  color: #222;\n  padding-top: 3px;\n  padding-bottom: 4px;\n  text-transform: capitalize;\n}\n.vc-sketch-field--single {\n  flex: 1;\n  padding-left: 6px;\n}\n.vc-sketch-field--double {\n  flex: 2;\n}\n.vc-sketch-presets {\n  margin-right: -10px;\n  margin-left: -10px;\n  padding-left: 10px;\n  padding-top: 10px;\n  border-top: 1px solid #eee;\n}\n.vc-sketch-presets-color {\n  border-radius: 3px;\n  overflow: hidden;\n  position: relative;\n  display: inline-block;\n  margin: 0 10px 10px 0;\n  vertical-align: top;\n  cursor: pointer;\n  width: 16px;\n  height: 16px;\n  box-shadow: inset 0 0 0 1px rgba(0,0,0,.15);\n}\n.vc-sketch__disable-alpha .vc-sketch-color-wrap {\n  height: 10px;\n}\n",""])},function(e,t,n){"use strict";var r=function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("div",{class:["vc-sketch",e.disableAlpha?"vc-sketch__disable-alpha":""]},[n("div",{staticClass:"vc-sketch-saturation-wrap"},[n("saturation",{on:{change:e.childChange},model:{value:e.colors,callback:function(t){e.colors=t},expression:"colors"}})],1),e._v(" "),n("div",{staticClass:"vc-sketch-controls"},[n("div",{staticClass:"vc-sketch-sliders"},[n("div",{staticClass:"vc-sketch-hue-wrap"},[n("hue",{on:{change:e.childChange},model:{value:e.colors,callback:function(t){e.colors=t},expression:"colors"}})],1),e._v(" "),e.disableAlpha?e._e():n("div",{staticClass:"vc-sketch-alpha-wrap"},[n("alpha",{on:{change:e.childChange},model:{value:e.colors,callback:function(t){e.colors=t},expression:"colors"}})],1)]),e._v(" "),n("div",{staticClass:"vc-sketch-color-wrap"},[n("div",{staticClass:"vc-sketch-active-color",style:{background:e.activeColor}}),e._v(" "),n("checkboard")],1)]),e._v(" "),e.disableFields?e._e():n("div",{staticClass:"vc-sketch-field"},[n("div",{staticClass:"vc-sketch-field--double"},[n("ed-in",{attrs:{label:"hex",value:e.hex},on:{change:e.inputChange}})],1),e._v(" "),n("div",{staticClass:"vc-sketch-field--single"},[n("ed-in",{attrs:{label:"r",value:e.colors.rgba.r},on:{change:e.inputChange}})],1),e._v(" "),n("div",{staticClass:"vc-sketch-field--single"},[n("ed-in",{attrs:{label:"g",value:e.colors.rgba.g},on:{change:e.inputChange}})],1),e._v(" "),n("div",{staticClass:"vc-sketch-field--single"},[n("ed-in",{attrs:{label:"b",value:e.colors.rgba.b},on:{change:e.inputChange}})],1),e._v(" "),e.disableAlpha?e._e():n("div",{staticClass:"vc-sketch-field--single"},[n("ed-in",{attrs:{label:"a",value:e.colors.a,"arrow-offset":.01,max:1},on:{change:e.inputChange}})],1)]),e._v(" "),n("div",{staticClass:"vc-sketch-presets"},e._l(e.presetColors,function(t){return n("div",{key:t,staticClass:"vc-sketch-presets-color",style:{background:t},on:{click:function(n){e.handlePreset(t)}}})}))])},a=[];r._withStripped=!0;var i={render:r,staticRenderFns:a};t.a=i},function(e,t,n){"use strict";function r(e){c||n(72)}Object.defineProperty(t,"__esModule",{value:!0});var a=n(21),i=n.n(a);for(var o in a)"default"!==o&&function(e){n.d(t,e,function(){return a[e]})}(o);var s=n(74),c=!1,l=n(2),u=r,d=l(i.a,s.a,!1,u,null,null);d.options.__file="src/components/Chrome.vue",t.default=d.exports},function(e,t,n){var r=n(73);"string"==typeof r&&(r=[[e.i,r,""]]),r.locals&&(e.exports=r.locals);n(1)("2a2435f8",r,!1)},function(e,t,n){t=e.exports=n(0)(!1),t.push([e.i,"\n.vc-chrome {\n  background: #fff;\n  border-radius: 2px;\n  box-shadow: 0 0 2px rgba(0,0,0,.3), 0 4px 8px rgba(0,0,0,.3);\n  box-sizing: initial;\n  width: 225px;\n  font-family: Menlo;\n  background-color: #fff;\n}\n.vc-chrome-controls {\n  display: flex;\n}\n.vc-chrome-color-wrap {\n  position: relative;\n  width: 36px;\n}\n.vc-chrome-active-color {\n  position: relative;\n  width: 30px;\n  height: 30px;\n  border-radius: 15px;\n  overflow: hidden;\n  z-index: 1;\n}\n.vc-chrome-color-wrap .vc-checkerboard {\n  width: 30px;\n  height: 30px;\n  border-radius: 15px;\n  background-size: auto;\n}\n.vc-chrome-sliders {\n  flex: 1;\n}\n.vc-chrome-fields-wrap {\n  display: flex;\n  padding-top: 16px;\n}\n.vc-chrome-fields {\n  display: flex;\n  margin-left: -6px;\n  flex: 1;\n}\n.vc-chrome-field {\n  padding-left: 6px;\n  width: 100%;\n}\n.vc-chrome-toggle-btn {\n  width: 32px;\n  text-align: right;\n  position: relative;\n}\n.vc-chrome-toggle-icon {\n  margin-right: -4px;\n  margin-top: 12px;\n  cursor: pointer;\n  position: relative;\n  z-index: 2;\n}\n.vc-chrome-toggle-icon-highlight {\n  position: absolute;\n  width: 24px;\n  height: 28px;\n  background: #eee;\n  border-radius: 4px;\n  top: 10px;\n  left: 12px;\n}\n.vc-chrome-hue-wrap {\n  position: relative;\n  height: 10px;\n  margin-bottom: 8px;\n}\n.vc-chrome-alpha-wrap {\n  position: relative;\n  height: 10px;\n}\n.vc-chrome-hue-wrap .vc-hue {\n  border-radius: 2px;\n}\n.vc-chrome-alpha-wrap .vc-alpha-gradient {\n  border-radius: 2px;\n}\n.vc-chrome-hue-wrap .vc-hue-picker, .vc-chrome-alpha-wrap .vc-alpha-picker {\n  width: 12px;\n  height: 12px;\n  border-radius: 6px;\n  transform: translate(-6px, -2px);\n  background-color: rgb(248, 248, 248);\n  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.37);\n}\n.vc-chrome-body {\n  padding: 16px 16px 12px;\n  background-color: #fff;\n}\n.vc-chrome-saturation-wrap {\n  width: 100%;\n  padding-bottom: 55%;\n  position: relative;\n  border-radius: 2px 2px 0 0;\n  overflow: hidden;\n}\n.vc-chrome-saturation-wrap .vc-saturation-circle {\n  width: 12px;\n  height: 12px;\n}\n.vc-chrome-fields .vc-input__input {\n  font-size: 11px;\n  color: #333;\n  width: 100%;\n  border-radius: 2px;\n  border: none;\n  box-shadow: inset 0 0 0 1px #dadada;\n  height: 21px;\n  text-align: center;\n}\n.vc-chrome-fields .vc-input__label {\n  text-transform: uppercase;\n  font-size: 11px;\n  line-height: 11px;\n  color: #969696;\n  text-align: center;\n  display: block;\n  margin-top: 12px;\n}\n.vc-chrome__disable-alpha .vc-chrome-active-color {\n  width: 18px;\n  height: 18px;\n}\n.vc-chrome__disable-alpha .vc-chrome-color-wrap {\n  width: 30px;\n}\n.vc-chrome__disable-alpha .vc-chrome-hue-wrap {\n  margin-top: 4px;\n  margin-bottom: 4px;\n}\n",""])},function(e,t,n){"use strict";var r=function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("div",{class:["vc-chrome",e.disableAlpha?"vc-chrome__disable-alpha":""]},[n("div",{staticClass:"vc-chrome-saturation-wrap"},[n("saturation",{on:{change:e.childChange},model:{value:e.colors,callback:function(t){e.colors=t},expression:"colors"}})],1),e._v(" "),n("div",{staticClass:"vc-chrome-body"},[n("div",{staticClass:"vc-chrome-controls"},[n("div",{staticClass:"vc-chrome-color-wrap"},[n("div",{staticClass:"vc-chrome-active-color",style:{background:e.activeColor}}),e._v(" "),e.disableAlpha?e._e():n("checkboard")],1),e._v(" "),n("div",{staticClass:"vc-chrome-sliders"},[n("div",{staticClass:"vc-chrome-hue-wrap"},[n("hue",{on:{change:e.childChange},model:{value:e.colors,callback:function(t){e.colors=t},expression:"colors"}})],1),e._v(" "),e.disableAlpha?e._e():n("div",{staticClass:"vc-chrome-alpha-wrap"},[n("alpha",{on:{change:e.childChange},model:{value:e.colors,callback:function(t){e.colors=t},expression:"colors"}})],1)])]),e._v(" "),e.disableFields?e._e():n("div",{staticClass:"vc-chrome-fields-wrap"},[n("div",{directives:[{name:"show",rawName:"v-show",value:0===e.fieldsIndex,expression:"fieldsIndex === 0"}],staticClass:"vc-chrome-fields"},[n("div",{staticClass:"vc-chrome-field"},[n("ed-in",{attrs:{label:"hex",value:e.colors.hex},on:{change:e.inputChange}})],1)]),e._v(" "),n("div",{directives:[{name:"show",rawName:"v-show",value:1===e.fieldsIndex,expression:"fieldsIndex === 1"}],staticClass:"vc-chrome-fields"},[n("div",{staticClass:"vc-chrome-field"},[n("ed-in",{attrs:{label:"r",value:e.colors.rgba.r},on:{change:e.inputChange}})],1),e._v(" "),n("div",{staticClass:"vc-chrome-field"},[n("ed-in",{attrs:{label:"g",value:e.colors.rgba.g},on:{change:e.inputChange}})],1),e._v(" "),n("div",{staticClass:"vc-chrome-field"},[n("ed-in",{attrs:{label:"b",value:e.colors.rgba.b},on:{change:e.inputChange}})],1),e._v(" "),e.disableAlpha?e._e():n("div",{staticClass:"vc-chrome-field"},[n("ed-in",{attrs:{label:"a",value:e.colors.a,"arrow-offset":.01,max:1},on:{change:e.inputChange}})],1)]),e._v(" "),n("div",{directives:[{name:"show",rawName:"v-show",value:2===e.fieldsIndex,expression:"fieldsIndex === 2"}],staticClass:"vc-chrome-fields"},[n("div",{staticClass:"vc-chrome-field"},[n("ed-in",{attrs:{label:"h",value:e.hsl.h},on:{change:e.inputChange}})],1),e._v(" "),n("div",{staticClass:"vc-chrome-field"},[n("ed-in",{attrs:{label:"s",value:e.hsl.s},on:{change:e.inputChange}})],1),e._v(" "),n("div",{staticClass:"vc-chrome-field"},[n("ed-in",{attrs:{label:"l",value:e.hsl.l},on:{change:e.inputChange}})],1),e._v(" "),e.disableAlpha?e._e():n("div",{staticClass:"vc-chrome-field"},[n("ed-in",{attrs:{label:"a",value:e.colors.a,"arrow-offset":.01,max:1},on:{change:e.inputChange}})],1)]),e._v(" "),n("div",{staticClass:"vc-chrome-toggle-btn",on:{click:e.toggleViews}},[n("div",{staticClass:"vc-chrome-toggle-icon"},[n("svg",{staticStyle:{width:"24px",height:"24px"},attrs:{viewBox:"0 0 24 24"},on:{mouseover:e.showHighlight,mouseenter:e.showHighlight,mouseout:e.hideHighlight}},[n("path",{attrs:{fill:"#333",d:"M12,18.17L8.83,15L7.42,16.41L12,21L16.59,16.41L15.17,15M12,5.83L15.17,9L16.58,7.59L12,3L7.41,7.59L8.83,9L12,5.83Z"}})])]),e._v(" "),n("div",{directives:[{name:"show",rawName:"v-show",value:e.highlight,expression:"highlight"}],staticClass:"vc-chrome-toggle-icon-highlight"})])])])])},a=[];r._withStripped=!0;var i={render:r,staticRenderFns:a};t.a=i}])});

/***/ }),

/***/ 282:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"colour-picker"},[_c('input',{ref:"field",attrs:{"readonly":"","type":"text"},domProps:{"value":_vm.hex},on:{"focus":function($event){_vm.active = true},"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"esc",27,$event.key)){ return null; }_vm.active = false},"&blur":function($event){_vm.active = false}}}),_vm._v(" "),_c('div',{staticClass:"preview",style:(_vm.previewStyle),on:{"click":function($event){_vm.active = true}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.active),expression:"active"}],staticClass:"picker",on:{"mousedown":function($event){$event.preventDefault();_vm.onMousedown($event)}}},[_c('compact-picker',{attrs:{"disableAlpha":true},model:{value:(_vm.hex),callback:function ($$v) {_vm.hex=$$v},expression:"hex"}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 283:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"inspector"},[(!_vm.currentElement)?_c('div',{staticClass:"slide-properties section"},[_c('div',{staticClass:"header"},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.toggleSection($event)}}},[_vm._v("PROPERTIES")]),_vm._v(" "),_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.toggleSection($event)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("arrow_drop_down")])])]),_vm._v(" "),_c('div',{staticClass:"options"},[_c('label',[_vm._v("Background")]),_vm._v(" "),_c('colour-picker',{attrs:{"value":_vm.backgroundColour},on:{"update:value":function($event){_vm.backgroundColour=$event}}})],1)]):_vm._e(),_vm._v(" "),(_vm.isTextElement)?_c('div',{staticClass:"appearance section"},[_c('div',{staticClass:"header"},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.toggleSection($event)}}},[_vm._v("APPEARANCE")]),_vm._v(" "),_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.toggleSection($event)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("arrow_drop_down")])])]),_vm._v(" "),_c('div',{staticClass:"options"},[_c('label',[_vm._v("Fill")]),_vm._v(" "),_c('colour-picker',{attrs:{"value":_vm.fill},on:{"update:value":function($event){_vm.fill=$event}}}),_vm._v(" "),_c('label',[_vm._v("Value")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.content),expression:"content"}],attrs:{"type":"text"},domProps:{"value":(_vm.content)},on:{"input":function($event){if($event.target.composing){ return; }_vm.content=$event.target.value}}})],1)]):_vm._e(),_vm._v(" "),(_vm.currentElement)?_c('div',{staticClass:"position section"},[_c('div',{staticClass:"header"},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.toggleSection($event)}}},[_vm._v("POSITION")]),_vm._v(" "),_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.toggleSection($event)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("arrow_drop_down")])])]),_vm._v(" "),_c('div',{staticClass:"options"},[_c('label',[_vm._v("X")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.xPosition),expression:"xPosition"}],attrs:{"type":"number","min":"0","step":"1"},domProps:{"value":(_vm.xPosition)},on:{"input":function($event){if($event.target.composing){ return; }_vm.xPosition=$event.target.value}}}),_vm._v(" "),_c('label',[_vm._v("Y")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.yPosition),expression:"yPosition"}],attrs:{"type":"number","min":"0","step":"1"},domProps:{"value":(_vm.yPosition)},on:{"input":function($event){if($event.target.composing){ return; }_vm.yPosition=$event.target.value}}})])]):_vm._e(),_vm._v(" "),(_vm.isTextElement)?_c('div',{staticClass:"font section"},[_c('div',{staticClass:"header"},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.toggleSection($event)}}},[_vm._v("FONT")]),_vm._v(" "),_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.toggleSection($event)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("arrow_drop_down")])])]),_vm._v(" "),_c('div',{staticClass:"options"},[_c('label',[_vm._v("Family")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.fontFamily),expression:"fontFamily"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.fontFamily=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.fonts),function(font){return _c('option',{domProps:{"value":font.name}},[_vm._v(_vm._s(font.name))])})),_vm._v(" "),_c('label',[_vm._v("Size")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fontSize),expression:"fontSize"}],attrs:{"type":"number","step":"5","min":"10","max":"200"},domProps:{"value":(_vm.fontSize)},on:{"input":function($event){if($event.target.composing){ return; }_vm.fontSize=$event.target.value}}})])]):_vm._e(),_vm._v(" "),(_vm.currentElement)?_c('a',{staticClass:"delete",attrs:{"href":"#"},on:{"click":function($event){_vm.deleteElement(_vm.currentElement.id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("delete")]),_vm._v(" "),_c('span',[_vm._v("Delete element")])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 284:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SlideControls_vue__ = __webpack_require__(249);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3219a18c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SlideControls_vue__ = __webpack_require__(287);
function injectStyle (ssrContext) {
  __webpack_require__(285)
}
var normalizeComponent = __webpack_require__(27)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SlideControls_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3219a18c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SlideControls_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 285:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(286);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(205)("169942af", content, true, {});

/***/ }),

/***/ 286:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(204)(true);
// imports


// module
exports.push([module.i, ".slide-controls{grid-area:slide-controls;background-color:rgba(0,0,0,.5);padding:1em;z-index:2;display:grid;grid-template-columns:auto 1fr auto;grid-template-areas:\"zoom . users\"}.slide-controls .zoom{list-style:none;grid-area:zoom;display:grid;grid-template-columns:1fr 1.5fr 1fr;grid-gap:2px}.slide-controls .zoom li{background-color:hsla(0,0%,100%,.2);padding:.2em;font-size:.9em;font-weight:700;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.slide-controls .zoom li,.slide-controls .zoom li a{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.slide-controls .zoom li a{font-size:.6em;padding:0 .3em}.slide-controls .zoom li:first-child{background-color:hsla(0,0%,100%,.1);border-radius:5px 0 0 5px}.slide-controls .zoom li:last-child{background-color:hsla(0,0%,100%,.1);border-radius:0 5px 5px 0}.slide-controls .users{grid-area:users;list-style:none;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.slide-controls .users,.slide-controls .users li{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.slide-controls .users li{margin-left:.5em;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;border-radius:100px;font-size:1.2em;padding:.5em .8em;font-weight:700;color:#fff;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-webkit-transition:all .2s ease-in-out;transition:all .2s ease-in-out;text-shadow:2px 2px 0 rgba(0,0,0,.2);position:relative}.slide-controls .users li:first-child{background-color:#1a375a}.slide-controls .users li:nth-child(2){background-color:#632857}.slide-controls .users li:nth-child(3){background-color:#1cbdab}.slide-controls .users li:nth-child(4){background-color:#d81d41}.slide-controls .users li:nth-child(5){background-color:#ff501e}.slide-controls .users li span{visibility:hidden;opacity:0;position:absolute;top:-60%;right:0;white-space:nowrap;font-size:.8em;padding:.5em .7em;display:inline-block;border-radius:5px;background-color:rgba(0,0,0,.8);color:#fff;-webkit-transform:translateY(20%);transform:translateY(20%)}.slide-controls .users li:hover{-webkit-transform:translateY(-5px) scale(1.1);transform:translateY(-5px) scale(1.1);-webkit-transition:all .2s;transition:all .2s}.slide-controls .users li:hover span{visibility:visible;opacity:1;-webkit-transform:none;transform:none;-webkit-transition:all .4s;transition:all .4s}", "", {"version":3,"sources":["/home/forge/slidekick.daniel-waghorn.com/src/components/SlideControls.vue"],"names":[],"mappings":"AACA,gBACE,yBAA0B,AAC1B,gCAAqC,AACrC,YAAa,AACb,UAAW,AAEX,aAAc,AACd,oCAAqC,AACrC,kCAAoC,CACrC,AACD,sBACE,gBAAiB,AACjB,eAAgB,AAEhB,aAAc,AACd,oCAAqC,AACrC,YAAc,CACf,AACD,yBACE,oCAA2C,AAC3C,aAAe,AACf,eAAiB,AACjB,gBAAkB,AAClB,yBAA0B,AACvB,sBAAuB,AACtB,qBAAsB,AAClB,gBAAkB,CAC3B,AACD,oDAEE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,wBAAyB,AACrB,qBAAsB,AAClB,sBAAwB,CACjC,AACD,2BACE,eAAiB,AACjB,cAAiB,CAClB,AACD,qCACE,oCAA2C,AAC3C,yBAA2B,CAC5B,AACD,oCACE,oCAA2C,AAC3C,yBAA2B,CAC5B,AACD,uBACE,gBAAiB,AACjB,gBAAiB,AAUjB,yBAA0B,AACtB,sBAAuB,AACnB,6BAA+B,CACxC,AACD,iDAZE,oBAAqB,AAErB,oBAAqB,AAErB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,kBAAoB,CA6B7B,AAxBD,0BACE,iBAAmB,AAOnB,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,oBAAqB,AACrB,gBAAiB,AACjB,kBAAqB,AACrB,gBAAkB,AAClB,WAAa,AACb,yBAA0B,AACvB,sBAAuB,AACtB,qBAAsB,AAClB,iBAAkB,AAC1B,uCAAyC,AACzC,+BAAiC,AACjC,qCAA0C,AAC1C,iBAAmB,CACpB,AACD,sCACE,wBAAkC,CACnC,AACD,uCACE,wBAA0B,CAC3B,AACD,uCACE,wBAA0B,CAC3B,AACD,uCACE,wBAA0B,CAC3B,AACD,uCACE,wBAA0B,CAC3B,AACD,+BACE,kBAAmB,AACnB,UAAW,AACX,kBAAmB,AACnB,SAAU,AACV,QAAS,AACT,mBAAoB,AACpB,eAAiB,AACjB,kBAAqB,AACrB,qBAAsB,AACtB,kBAAmB,AACnB,gCAAqC,AACrC,WAAa,AACb,kCAAmC,AAC3B,yBAA2B,CACpC,AACD,gCACE,8CAA+C,AACvC,sCAAuC,AAC/C,2BAA6B,AAC7B,kBAAqB,CACtB,AACD,qCACE,mBAAoB,AACpB,UAAW,AACX,uBAAwB,AAChB,eAAgB,AACxB,2BAA6B,AAC7B,kBAAqB,CACtB","file":"SlideControls.vue","sourcesContent":["\n.slide-controls {\n  grid-area: slide-controls;\n  background-color: rgba(0, 0, 0, 0.5);\n  padding: 1em;\n  z-index: 2;\n  \n  display: grid;\n  grid-template-columns: auto 1fr auto;\n  grid-template-areas: \"zoom . users\";\n}\n.slide-controls .zoom {\n  list-style: none;\n  grid-area: zoom;\n  \n  display: grid;\n  grid-template-columns: 1fr 1.5fr 1fr;\n  grid-gap: 2px;\n}\n.slide-controls .zoom li {\n  background-color: rgba(255, 255, 255, 0.2);\n  padding: 0.2em;\n  font-size: 0.9em;\n  font-weight: bold;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n}\n.slide-controls .zoom li,\n.slide-controls .zoom li a {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.slide-controls .zoom li a {\n  font-size: 0.6em;\n  padding: 0 0.3em;\n}\n.slide-controls .zoom li:first-child {\n  background-color: rgba(255, 255, 255, 0.1);\n  border-radius: 5px 0 0 5px;\n}\n.slide-controls .zoom li:last-child {\n  background-color: rgba(255, 255, 255, 0.1);\n  border-radius: 0 5px 5px 0;\n}\n.slide-controls .users {\n  grid-area: users;\n  list-style: none;\n\n  display: -webkit-box;\n\n  display: -ms-flexbox;\n\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.slide-controls .users li {\n  margin-left: 0.5em;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  border-radius: 100px;\n  font-size: 1.2em;\n  padding: 0.5em 0.8em;\n  font-weight: bold;\n  color: white;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  -webkit-transition: 0.2s all ease-in-out;\n  transition: 0.2s all ease-in-out;\n  text-shadow: 2px 2px 0 rgba(0, 0, 0, 0.2);\n  position: relative;\n}\n.slide-controls .users li:nth-child(1) {\n  background-color: rgb(26, 55, 90);\n}\n.slide-controls .users li:nth-child(2) {\n  background-color: #632857;\n}\n.slide-controls .users li:nth-child(3) {\n  background-color: #1CBDAB;\n}\n.slide-controls .users li:nth-child(4) {\n  background-color: #D81D41;\n}\n.slide-controls .users li:nth-child(5) {\n  background-color: #FF501E;\n}\n.slide-controls .users li span {\n  visibility: hidden;\n  opacity: 0;\n  position: absolute;\n  top: -60%;\n  right: 0;\n  white-space: nowrap;\n  font-size: 0.8em;\n  padding: 0.5em 0.7em;\n  display: inline-block;\n  border-radius: 5px;\n  background-color: rgba(0, 0, 0, 0.8);\n  color: white;\n  -webkit-transform: translateY(20%);\n          transform: translateY(20%);\n}\n.slide-controls .users li:hover {\n  -webkit-transform: translateY(-5px) scale(1.1);\n          transform: translateY(-5px) scale(1.1);\n  -webkit-transition: 0.2s all;\n  transition: 0.2s all;\n}\n.slide-controls .users li:hover span {\n  visibility: visible;\n  opacity: 1;\n  -webkit-transform: none;\n          transform: none;\n  -webkit-transition: 0.4s all;\n  transition: 0.4s all;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 287:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"slide-controls"},[_c('ul',{staticClass:"zoom"},[_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":_vm.zoomIn}},[_c('i',{staticClass:"material-icons"},[_vm._v("zoom_in")])])]),_vm._v(" "),_c('li',[_vm._v(_vm._s(_vm._f("percent")(_vm.zoomLevel)))]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":_vm.zoomOut}},[_c('i',{staticClass:"material-icons"},[_vm._v("zoom_out")])])])]),_vm._v(" "),_c('ul',{staticClass:"users"},_vm._l((_vm.activeUsers),function(user){return (user.id !== _vm.current_user.id)?_c('li',[_vm._v("\n      "+_vm._s(_vm._f("initial")(user.name))+"\n      "),_c('span',[_vm._v(_vm._s(user.name)+" is editing")])]):_vm._e()}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 288:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"editor",class:_vm.computedStyles,on:{"click":_vm.clearInspector}},[(!_vm.loading)?[_c('slides-toolbar'),_vm._v(" "),_c('toolbox'),_vm._v(" "),_c('inspector'),_vm._v(" "),_c('slide-controls'),_vm._v(" "),_c('current-slide',{attrs:{"selected-slide-index":_vm.selectedSlideIndex,"slides":_vm.slides,"zoom-level":_vm.zoomLevel}}),_vm._v(" "),_vm._m(0)]:_vm._e()],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"no-slides-message"},[_c('i',{staticClass:"material-icons"},[_vm._v("create")]),_vm._v("\n      To get started, add a new slide\n    ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/0.3082c4087a0f8fb5004f.js